var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 72 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_962",
  "data-name": "Path 962",
  d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
  fill: "#ededff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "man_is_working_on_a_strategy",
  "data-name": "man is working on a strategy",
  transform: "translate(-175 -214)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_963",
  "data-name": "Path 963",
  d: "M1214.864,1369.468,1192.43,1365a.386.386,0,0,1-.205-.643l4.929-5.237a.971.971,0,0,1,.874-.29l21.574,3.807a.389.389,0,0,1,.32.414.391.391,0,0,1-.061.179l-3.682,5.679a1.271,1.271,0,0,1-1.313.554Z",
  transform: "translate(-985.091 -1117.561)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_964",
  "data-name": "Path 964",
  d: "M1210.805,1365.245a1.385,1.385,0,0,1-.272-.027l-22.435-4.464a.49.49,0,0,1-.261-.816l4.929-5.238a1.069,1.069,0,0,1,.968-.321l21.573,3.808a.492.492,0,0,1,.328.753l-3.682,5.678a1.366,1.366,0,0,1-1.148.626Zm-17.258-10.673a.861.861,0,0,0-.629.272l-4.929,5.236a.282.282,0,0,0,.15.469l22.435,4.464a1.158,1.158,0,0,0,1.2-.509l3.682-5.678a.284.284,0,0,0-.063-.378.281.281,0,0,0-.126-.057l-21.572-3.806a.823.823,0,0,0-.151-.013Z",
  transform: "translate(-980.781 -1113.209)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_965",
  "data-name": "Path 965",
  d: "M1408.449,1446.154l-16.646-3.183c-.226-.046-.324-.264-.174-.39l1.913-1.855a.807.807,0,0,1,.651-.149l16.387,2.891c.208.036.319.227.212.363l-1.37,2.029A1.013,1.013,0,0,1,1408.449,1446.154Z",
  transform: "translate(-1179.781 -1197.358)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_966",
  "data-name": "Path 966",
  d: "M1405.809,1443.338a1.287,1.287,0,0,1-.248-.024l-16.646-3.185a.363.363,0,0,1-.294-.248.255.255,0,0,1,.086-.262l1.912-1.853,0,0a.873.873,0,0,1,.708-.164l16.387,2.891a.377.377,0,0,1,.293.222.253.253,0,0,1-.037.25l-1.369,2.026,0,0A1,1,0,0,1,1405.809,1443.338Zm-15.094-5.47-1.912,1.852,0,0a.116.116,0,0,0-.043.123.224.224,0,0,0,.185.146l16.646,3.183a.944.944,0,0,0,.905-.267l1.369-2.026,0,0a.111.111,0,0,0,.025-.055.113.113,0,0,0-.007-.061.235.235,0,0,0-.077-.091.238.238,0,0,0-.111-.043l-16.387-2.891A.736.736,0,0,0,1390.715,1437.868Z",
  transform: "translate(-1176.906 -1194.449)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_967",
  "data-name": "Path 967",
  d: "M1393.526,1564.32l-16.166-3.107a.412.412,0,0,1-.323-.481h0a.412.412,0,0,1,.481-.324l16.446,3.191C1394.663,1563.791,1394.2,1564.476,1393.526,1564.32Z",
  transform: "translate(-1165.598 -1314.341)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_968",
  "data-name": "Path 968",
  d: "M1391.134,1561.555a.948.948,0,0,1-.211-.026l-16.165-3.1a.48.48,0,0,1,.182-.943l16.446,3.19h.005c.352.1.431.311.388.479A.637.637,0,0,1,1391.134,1561.555Zm-16.286-3.945a.342.342,0,0,0-.062.677l16.166,3.107h0a.562.562,0,0,0,.694-.278c.035-.139-.07-.249-.289-.31l-16.443-3.19a.345.345,0,0,0-.068-.006Z",
  transform: "translate(-1163.008 -1311.484)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_969",
  "data-name": "Path 969",
  d: "M1706.867,1479c-.061-.254-1.483.172-1.483.172s1.295-.494,1.243-.763-1.443.171-1.443.171.954-.471.929-.659-1.263.069-1.818.231c.442-.228.673-.492.36-.475a12.645,12.645,0,0,0-4.432,1.565c-.789.555-.253,4.347-.253,4.347C1703.65,1480.671,1706.955,1479.365,1706.867,1479Z",
  transform: "translate(-1480.676 -1233.586)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_970",
  "data-name": "Path 970",
  d: "M1695.556,1479.458a.1.1,0,0,1-.082-.04.106.106,0,0,1-.021-.05c-.056-.394-.521-3.87.3-4.445a12.743,12.743,0,0,1,4.485-1.584c.175-.01.231.061.249.122a.247.247,0,0,1-.083.22,2.991,2.991,0,0,1,1.333-.114.149.149,0,0,1,.046.045.15.15,0,0,1,.023.06c.013.1-.086.222-.3.37a1.281,1.281,0,0,1,.719-.014.183.183,0,0,1,.059.052.181.181,0,0,1,.031.072c.025.139-.093.277-.393.452a1.009,1.009,0,0,1,.543.019.17.17,0,0,1,.057.048.176.176,0,0,1,.032.067c.052.219-.291.425-1.489,1.11a41.383,41.383,0,0,0-5.446,3.585.1.1,0,0,1-.064.024Zm4.687-5.91a12.425,12.425,0,0,0-4.374,1.545c-.572.4-.38,2.919-.234,4.066a41.909,41.909,0,0,1,5.328-3.489,7.951,7.951,0,0,0,1.377-.873,4.049,4.049,0,0,0-1.341.24.1.1,0,1,1-.067-.2,3.361,3.361,0,0,0,1.173-.638,3.6,3.6,0,0,0-1.3.242.1.1,0,0,1-.128-.06.1.1,0,0,1,0-.076.1.1,0,0,1,.051-.056,3.852,3.852,0,0,0,.843-.523,6.819,6.819,0,0,0-1.656.289.1.1,0,0,1-.075-.006.1.1,0,0,1-.052-.13.1.1,0,0,1,.05-.056A1.608,1.608,0,0,0,1700.243,1473.547Z",
  transform: "translate(-1476.263 -1229.352)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_971",
  "data-name": "Path 971",
  d: "M1703.147,1491.19a11.968,11.968,0,0,0-2.924,1.245c-.789.555-.253,4.346-.253,4.346a36.09,36.09,0,0,1,4.986-3.313A5.743,5.743,0,0,0,1703.147,1491.19Z",
  transform: "translate(-1480.676 -1246.779)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_972",
  "data-name": "Path 972",
  d: "M1485.35,1435.738a4.8,4.8,0,0,1,2.879.411l-2.245.875Z",
  transform: "translate(-1271.34 -1192.582)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_973",
  "data-name": "Path 973",
  d: "M1481.718,1432.791a.1.1,0,0,1-.054-.016.1.1,0,0,1-.038-.042l-.635-1.286a.106.106,0,0,1-.01-.046.1.1,0,0,1,.011-.046.1.1,0,0,1,.03-.036.1.1,0,0,1,.042-.02,4.855,4.855,0,0,1,2.948.42.1.1,0,0,1,.042.041.106.106,0,0,1,.014.057.1.1,0,0,1-.066.092l-2.244.875A.111.111,0,0,1,1481.718,1432.791Zm-.479-1.309.531,1.075,1.931-.753a4.785,4.785,0,0,0-2.461-.322Z",
  transform: "translate(-1267.074 -1188.246)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_974",
  "data-name": "Path 974",
  d: "M1485.35,1435.693l.634,1.286,1.088-.424a2.294,2.294,0,0,0-.447-.9,4.716,4.716,0,0,0-1.275.043Z",
  transform: "translate(-1271.34 -1192.538)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_975",
  "data-name": "Path 975",
  d: "M1729.46,2286.124s7.26,4.864,7.079,8.871H1739l-.591-.458s.041-7.768-5.549-11.427Z",
  transform: "translate(-1509.637 -2019.843)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_976",
  "data-name": "Path 976",
  d: "M1734.664,2290.841H1732.2a.1.1,0,0,1-.075-.032.1.1,0,0,1-.022-.035.1.1,0,0,1-.006-.041c.092-2.031-1.818-4.305-3.436-5.857a30.308,30.308,0,0,0-3.6-2.925.1.1,0,0,1-.032-.034.109.109,0,0,1-.014-.045.108.108,0,0,1,.008-.046.1.1,0,0,1,.027-.038l3.4-3.013a.1.1,0,0,1,.062-.026.106.106,0,0,1,.065.017,10.926,10.926,0,0,1,3.256,3.36,14.749,14.749,0,0,1,1.657,3.783,17.7,17.7,0,0,1,.682,4.319l.551.427a.1.1,0,0,1,.033.115.1.1,0,0,1-.037.05.1.1,0,0,1-.059.02Zm-2.352-.208h2.048l-.351-.272a.1.1,0,0,1-.03-.036.1.1,0,0,1-.01-.046,17.313,17.313,0,0,0-.676-4.318,12.341,12.341,0,0,0-4.759-6.977l-3.237,2.873a30.9,30.9,0,0,1,3.511,2.867C1731.156,2286.976,1732.335,2288.962,1732.311,2290.633Z",
  transform: "translate(-1505.305 -2015.585)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_977",
  "data-name": "Path 977",
  d: "M1735.314,2285.416a10.5,10.5,0,0,0-2.458-2.246l-3.4,3.013s1.041.7,2.324,1.781A18.727,18.727,0,0,1,1735.314,2285.416Z",
  transform: "translate(-1509.637 -2019.901)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_978",
  "data-name": "Path 978",
  d: "M1824.721,2447.569h-.008a.018.018,0,0,1-.008-.01.018.018,0,0,1,0-.013.826.826,0,0,1,.381-.352.018.018,0,0,1,.013,0,.017.017,0,0,1,.01.009.015.015,0,0,1,0,.007.016.016,0,0,1,0,.007.015.015,0,0,1,0,.006l-.006,0a.792.792,0,0,0-.364.337l-.007.005Z",
  transform: "translate(-1602.613 -2180.018)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_979",
  "data-name": "Path 979",
  d: "M1878.229,2367.11l-.007,0a.013.013,0,0,1-.006,0,.018.018,0,0,1,0-.012.019.019,0,0,1,0-.012,6.361,6.361,0,0,1,1.017-.687.018.018,0,0,1,.013,0,.021.021,0,0,1,.01.009.015.015,0,0,1,0,.006.016.016,0,0,1,0,.007l0,.006-.005,0a6.329,6.329,0,0,0-1.011.684l-.009,0Z",
  transform: "translate(-1654.845 -2101.14)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_980",
  "data-name": "Path 980",
  d: "M1915.965,2380.6a.016.016,0,0,1-.01,0,.017.017,0,0,1-.006-.008.018.018,0,0,1,0-.011.018.018,0,0,1,.006-.009l.581-.431a.018.018,0,0,1,.013,0,.019.019,0,0,1,.011.007.016.016,0,0,1,0,.006.018.018,0,0,1,0,.007.014.014,0,0,1,0,.006l0,0-.581.43a.016.016,0,0,1-.01,0Z",
  transform: "translate(-1691.684 -2114.557)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_981",
  "data-name": "Path 981",
  d: "M1839.126,2409.7h-.007l-.006,0a.018.018,0,0,1,0-.013.017.017,0,0,1,.006-.012,3.275,3.275,0,0,1,1.048-.577h.007l.006,0,.006,0a.017.017,0,0,1,0,.006.026.026,0,0,1,0,.007.018.018,0,0,1,0,.006l0,.005-.006,0a3.248,3.248,0,0,0-1.037.571.015.015,0,0,1-.011,0Z",
  transform: "translate(-1616.675 -2142.829)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_982",
  "data-name": "Path 982",
  d: "M1659.917,2783.042h-16.28a.046.046,0,0,1-.033-.013.046.046,0,0,1,0-.065.046.046,0,0,1,.033-.014h16.28a.046.046,0,1,1,0,.092Z",
  transform: "translate(-1425.812 -2507.781)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_983",
  "data-name": "Path 983",
  d: "M2022.26,2738.87a3.6,3.6,0,0,1,.1,1.033h1.259A2.29,2.29,0,0,0,2022.26,2738.87Z",
  transform: "translate(-1795.465 -2464.75)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_984",
  "data-name": "Path 984",
  d: "M2020.772,2737.132h-1.259a.072.072,0,0,1-.03-.006.071.071,0,0,1-.024-.018.069.069,0,0,1-.014-.027.071.071,0,0,1,0-.03,3.2,3.2,0,0,0-.1-1.006.07.07,0,0,1,0-.035.069.069,0,0,1,.051-.046.067.067,0,0,1,.035,0,2.351,2.351,0,0,1,1.408,1.073.065.065,0,0,1,0,.032.068.068,0,0,1-.012.03.063.063,0,0,1-.024.021.065.065,0,0,1-.032.008Zm-1.181-.138h1.071a2.282,2.282,0,0,0-1.162-.86A3.753,3.753,0,0,1,2019.591,2736.993Z",
  transform: "translate(-1792.613 -2461.91)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_985",
  "data-name": "Path 985",
  d: "M2013.119,2695.712c.622-.089,1.362-.185,1.969-.315a3.318,3.318,0,0,0-.073-.5,10.905,10.905,0,0,1-2.055.347C2013.034,2695.5,2013.119,2695.712,2013.119,2695.712Z",
  transform: "translate(-1786.387 -2421.827)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_986",
  "data-name": "Path 986",
  d: "M2010.271,2692.947a.069.069,0,0,1-.064-.043c0-.009-.087-.219-.161-.471a.07.07,0,0,1,0-.031.072.072,0,0,1,.012-.029.067.067,0,0,1,.023-.021.074.074,0,0,1,.03-.009,10.75,10.75,0,0,0,2.042-.345.07.07,0,0,1,.028,0,.069.069,0,0,1,.026.01.075.075,0,0,1,.021.02.074.074,0,0,1,.011.026,3.243,3.243,0,0,1,.074.516.071.071,0,0,1-.017.041.07.07,0,0,1-.038.022c-.5.109-1.1.193-1.633.268l-.341.046Zm-.067-.47c.044.138.088.26.112.323l.287-.041c.509-.071,1.082-.152,1.567-.254-.007-.092-.035-.25-.056-.355a10.991,10.991,0,0,1-1.909.327Z",
  transform: "translate(-1783.539 -2418.993)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_987",
  "data-name": "Path 987",
  d: "M2095.009,2763.41a1.089,1.089,0,0,0-.259.448h.838Z",
  transform: "translate(-1866.229 -2488.706)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_988",
  "data-name": "Path 988",
  d: "M2092.733,2761.065h-.838a.071.071,0,0,1-.032-.008.067.067,0,0,1-.025-.021.071.071,0,0,1-.012-.031.072.072,0,0,1,0-.033,1.118,1.118,0,0,1,.278-.477.07.07,0,0,1,.089,0l.579.449a.068.068,0,0,1,.024.035.07.07,0,0,1,0,.042.069.069,0,0,1-.025.034.071.071,0,0,1-.041.013Zm-.74-.138h.535l-.37-.287a.983.983,0,0,0-.163.287Z",
  transform: "translate(-1863.374 -2485.843)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_989",
  "data-name": "Path 989",
  d: "M2102.175,2718.343h0a.069.069,0,0,1-.065-.073,1.851,1.851,0,0,1,.3-.9c.108-.165.241-.231.356-.179a.233.233,0,0,1,.121.255,1.312,1.312,0,0,1-.264.6,2.517,2.517,0,0,1,1.122-.081.07.07,0,0,1,.045.028.07.07,0,0,1-.067.109,2.38,2.38,0,0,0-1.341.185.3.3,0,0,1-.066.03.07.07,0,0,1-.038,0,.072.072,0,0,1-.032-.018.07.07,0,0,1-.027.03A.066.066,0,0,1,2102.175,2718.343Zm.506-1.032c-.05,0-.114.063-.16.134a1.71,1.71,0,0,0-.269.748l.007,0,.059-.028a1.237,1.237,0,0,0,.426-.727c0-.065-.01-.1-.042-.12a.045.045,0,0,0-.021,0Z",
  transform: "translate(-1873.41 -2443.57)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_990",
  "data-name": "Path 990",
  d: "M1000.573,2492.27a29.575,29.575,0,0,0-2.774,6.9h2.459l-.592-.458a29.74,29.74,0,0,1,4.208-5.522Z",
  transform: "translate(-795.398 -2224.022)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_991",
  "data-name": "Path 991",
  d: "M996,2494.909h-2.459a.1.1,0,0,1-.045-.01.106.106,0,0,1-.036-.028.1.1,0,0,1-.02-.042.1.1,0,0,1,0-.046,29.976,29.976,0,0,1,2.785-6.936.1.1,0,0,1,.119-.049l3.3.925a.1.1,0,0,1,.047.027.1.1,0,0,1,.027.1.1.1,0,0,1-.028.047,29.259,29.259,0,0,0-4.145,5.421l.519.4a.1.1,0,0,1,.035.052.1.1,0,0,1,0,.063.1.1,0,0,1-.037.05.1.1,0,0,1-.06.02Zm-2.329-.208H995.7l-.351-.272a.1.1,0,0,1-.026-.135,30.483,30.483,0,0,1,4.1-5.418l-3.049-.854a29.812,29.812,0,0,0-2.7,6.679Z",
  transform: "translate(-791.143 -2219.652)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_992",
  "data-name": "Path 992",
  d: "M1081.006,2493.195l-3.3-.925s-.391.688-.893,1.74c.809.381,1.708.644,2.5,1.067a19.357,19.357,0,0,1,1.7-1.883Z",
  transform: "translate(-872.528 -2224.022)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_993",
  "data-name": "Path 993",
  d: "M1108.345,2545.162h-.006l-1.039-.416a.019.019,0,0,1-.01-.01.016.016,0,0,1,0-.013.019.019,0,0,1,.01-.01.017.017,0,0,1,.013,0l1.04.416.006,0,0,.006a.014.014,0,0,1,0,.007.017.017,0,0,1,0,.007.015.015,0,0,1-.006.007Z",
  transform: "translate(-902.28 -2275.216)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_994",
  "data-name": "Path 994",
  d: "M391.791,2783.042H364.907a.046.046,0,0,1,0-.092h26.884a.046.046,0,1,1,0,.092Z",
  transform: "translate(-177.531 -2507.781)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_995",
  "data-name": "Path 995",
  d: "M998.1,2738.87c-.1.344-.19.69-.266,1.033H999.1A1.631,1.631,0,0,0,998.1,2738.87Z",
  transform: "translate(-795.435 -2464.75)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_996",
  "data-name": "Path 996",
  d: "M996.22,2737.132h-1.259a.067.067,0,0,1-.03-.007.071.071,0,0,1-.024-.019.069.069,0,0,1-.013-.058c.073-.33.163-.679.267-1.038a.071.071,0,0,1,.034-.042.061.061,0,0,1,.026-.008.073.073,0,0,1,.027,0,1.667,1.667,0,0,1,1.037,1.073.066.066,0,0,1,0,.033.071.071,0,0,1-.036.052.066.066,0,0,1-.032.008Zm-1.172-.138h1.068a1.521,1.521,0,0,0-.842-.875C995.188,2736.419,995.112,2736.712,995.048,2736.993Z",
  transform: "translate(-792.56 -2461.91)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_997",
  "data-name": "Path 997",
  d: "M1016.17,2696.952c.59.215,1.194.37,1.791.54.062-.1.132-.208.208-.327-.614-.231-1.248-.386-1.85-.665Q1016.244,2696.724,1016.17,2696.952Z",
  transform: "translate(-813.331 -2423.389)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_998",
  "data-name": "Path 998",
  d: "M1015.12,2694.691l-.019,0-.424-.119c-.452-.126-.92-.257-1.372-.422a.07.07,0,0,1-.043-.087c.046-.145.1-.293.152-.454a.072.072,0,0,1,.015-.025.068.068,0,0,1,.024-.016.067.067,0,0,1,.028-.006.065.065,0,0,1,.028.006,9.981,9.981,0,0,0,1.156.428c.226.073.462.15.688.235a.073.073,0,0,1,.026.017.07.07,0,0,1,.016.027.067.067,0,0,1,0,.031.07.07,0,0,1-.01.029l-.208.324a.071.071,0,0,1-.025.026A.069.069,0,0,1,1015.12,2694.691Zm-1.7-.652c.428.153.871.277,1.3.4l.374.105c.041-.066.086-.139.134-.21-.2-.073-.4-.139-.6-.2a10.737,10.737,0,0,1-1.1-.4c-.04.11-.074.214-.106.315Z",
  transform: "translate(-810.49 -2420.519)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_999",
  "data-name": "Path 999",
  d: "M1066.159,2763.41a1.087,1.087,0,0,0-.259.448h.838Z",
  transform: "translate(-861.877 -2488.706)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1000",
  "data-name": "Path 1000",
  d: "M1063.886,2761.065h-.838a.072.072,0,0,1-.032-.008.067.067,0,0,1-.025-.021.065.065,0,0,1-.012-.031.071.071,0,0,1,0-.033,1.123,1.123,0,0,1,.277-.477.07.07,0,0,1,.089,0l.579.449a.067.067,0,0,1,.024.035.069.069,0,0,1-.026.076.07.07,0,0,1-.04.013Zm-.74-.138h.536l-.37-.287a.99.99,0,0,0-.164.287Z",
  transform: "translate(-859.026 -2485.843)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1001",
  "data-name": "Path 1001",
  d: "M1075.183,2736.435a.077.077,0,0,1-.024,0,2.713,2.713,0,0,0-1.1-.157h-.046a.071.071,0,0,1-.049-.02.069.069,0,0,1-.021-.049.075.075,0,0,1-.034,0,.073.073,0,0,1-.029-.017.069.069,0,0,1-.021-.049.069.069,0,0,1,.021-.049c.522-.538.861-.719,1.034-.555a.194.194,0,0,1,.06.087.192.192,0,0,1,.005.105c-.039.163-.313.31-.56.411a2.725,2.725,0,0,1,.786.163.069.069,0,0,1-.024.135Zm-.422-.816c-.088,0-.29.076-.72.508.379-.116.774-.3.8-.431,0-.009.007-.028-.025-.059a.084.084,0,0,0-.059-.019Z",
  transform: "translate(-869.648 -2461.438)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1002",
  "data-name": "Path 1002",
  d: "M1159.268,2574.047h-.008l-.33-.163a.018.018,0,0,1-.009-.01.019.019,0,0,1,0-.013.018.018,0,0,1,.023-.008l.329.163a.017.017,0,0,1,.009.008.016.016,0,0,1,0,.012.017.017,0,0,1-.006.01.018.018,0,0,1-.011,0Z",
  transform: "translate(-952.684 -2303.661)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1003",
  "data-name": "Path 1003",
  d: "M1118.319,2570.562h-.007l-.686-.3a.018.018,0,0,1-.009-.01.02.02,0,0,1,0-.013l0-.006.006,0h.013l.686.3a.017.017,0,0,1,.009.01.018.018,0,0,1,0,.013.016.016,0,0,1-.007.007Z",
  transform: "translate(-912.362 -2300.126)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1004",
  "data-name": "Path 1004",
  d: "M1928.7,1157.365c-.05.2-.86.194-.806,0a13.9,13.9,0,0,0,0-5.425h.806A13.246,13.246,0,0,1,1928.7,1157.365Z",
  transform: "translate(-1703.344 -915.607)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1005",
  "data-name": "Path 1005",
  d: "M1925.423,1154.739a.6.6,0,0,1-.393-.1.133.133,0,0,1-.037-.133,13.947,13.947,0,0,0,0-5.393.076.076,0,0,1,0-.031.066.066,0,0,1,.014-.027.065.065,0,0,1,.024-.019.071.071,0,0,1,.03-.007h.806a.07.07,0,0,1,.043.015.071.071,0,0,1,.024.039,13.425,13.425,0,0,1,0,5.456c-.019.074-.093.129-.216.163a1.186,1.186,0,0,1-.3.036Zm-.3-.2a.714.714,0,0,0,.448.051c.158-.021.219-.066.223-.084a13.2,13.2,0,0,0,.012-5.339h-.666A13.816,13.816,0,0,1,1925.128,1154.541Z",
  transform: "translate(-1700.51 -912.766)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1006",
  "data-name": "Path 1006",
  d: "M1827.967,1346.948l-4.448-.537a.431.431,0,0,0-.48.376h0a.431.431,0,0,0,.376.48l4.448.538a.432.432,0,0,0,.48-.377h0A.432.432,0,0,0,1827.967,1346.948Z",
  transform: "translate(-1600.984 -1105.443)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1007",
  "data-name": "Path 1007",
  d: "M1825.172,1345.052a.565.565,0,0,1-.061,0l-4.448-.537a.5.5,0,0,1,.12-.992l4.448.537a.5.5,0,0,1-.06,1Zm-4.448-1.4a.362.362,0,0,0-.043.722l4.448.537a.361.361,0,0,0,.141-.011.362.362,0,0,0,.218-.171.364.364,0,0,0,.044-.134.371.371,0,0,0-.011-.141.363.363,0,0,0-.305-.262l-4.448-.537-.043,0Z",
  transform: "translate(-1598.24 -1102.621)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1008",
  "data-name": "Path 1008",
  d: "M766.72,1073.267s-.64,1.8.024,1.677l.87.174-1.638,1.891-3.2.032,1.1-2.249s.324.317.794-.251a4.735,4.735,0,0,0,.525-2.141Z",
  transform: "translate(-565.968 -837.961)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1009",
  "data-name": "Path 1009",
  d: "M759.941,1074.259a.069.069,0,0,1-.062-.1l1.1-2.249a.067.067,0,0,1,.021-.024.064.064,0,0,1,.03-.013.067.067,0,0,1,.032,0,.07.07,0,0,1,.028.017.306.306,0,0,0,.216.068.741.741,0,0,0,.476-.313,4.7,4.7,0,0,0,.509-2.1.07.07,0,0,1,.01-.034.069.069,0,0,1,.093-.025l1.526.867a.069.069,0,0,1,.031.083c-.173.489-.383,1.341-.206,1.548a.142.142,0,0,0,.152.038.06.06,0,0,1,.026,0l.87.174a.068.068,0,0,1,.032.016.069.069,0,0,1,.022.065.071.071,0,0,1-.016.032L763.2,1074.2a.07.07,0,0,1-.052.024l-3.2.032Zm1.131-2.215-1.017,2.076,3.059-.03,1.539-1.778-.74-.148a.273.273,0,0,1-.269-.086c-.263-.306.068-1.353.161-1.629l-1.377-.783a4.353,4.353,0,0,1-.535,2.069.855.855,0,0,1-.579.364A.46.46,0,0,1,761.072,1072.044Z",
  transform: "translate(-563.136 -835.11)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1010",
  "data-name": "Path 1010",
  d: "M861.388,1073.267l-1.526-.867a7.674,7.674,0,0,1-.112,1.031,4.041,4.041,0,0,0,1.4.74,6.386,6.386,0,0,1,.242-.9Z",
  transform: "translate(-660.636 -837.961)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1011",
  "data-name": "Path 1011",
  d: "M1445.823,243.445l-21.107-2.788a.891.891,0,0,1-.772-.823l-1.384-20.508a.891.891,0,0,1,.932-.95L1448.7,219.6a.89.89,0,0,1,.841,1l-2.718,22.071a.891.891,0,0,1-1,.774Z",
  transform: "translate(-1210.042 -4.271)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1012",
  "data-name": "Path 1012",
  d: "M1441.706,239.287a.989.989,0,0,1-.133-.009l-21.107-2.788a1,1,0,0,1-.862-.917l-1.384-20.51a.995.995,0,0,1,1.041-1.061l25.208,1.226a1,1,0,0,1,.939,1.115l-2.718,22.07a.995.995,0,0,1-.985.873Zm-22.493-25.076a.787.787,0,0,0-.786.84l1.384,20.508a.789.789,0,0,0,.682.727l21.107,2.788a.786.786,0,0,0,.884-.684l2.718-22.07a.786.786,0,0,0-.742-.882l-25.207-1.227Z",
  transform: "translate(-1205.806 0)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1013",
  "data-name": "Path 1013",
  d: "M2245.1,1115.446a3.769,3.769,0,0,1-.574-.043,3.044,3.044,0,0,1-2.283-1.584,2.325,2.325,0,0,1-.133-.339,3.228,3.228,0,0,1-.313-.1,3.735,3.735,0,0,1-1.138-.686,2.571,2.571,0,0,0-1.483-.677.072.072,0,0,1-.046-.027.07.07,0,0,1-.014-.052.069.069,0,0,1,.027-.046.071.071,0,0,1,.052-.014,2.711,2.711,0,0,1,1.552.707,3.631,3.631,0,0,0,1.1.664c.074.028.149.053.224.074a2.244,2.244,0,0,1,.638-2.173,1.4,1.4,0,0,1,1.156-.365,1.249,1.249,0,0,1,.9,1.425,1.7,1.7,0,0,1-1.2,1.269,2.584,2.584,0,0,1-1.3.039,2.168,2.168,0,0,0,.1.241,2.905,2.905,0,0,0,2.18,1.508,4.538,4.538,0,0,0,2.688-.509,2.678,2.678,0,0,0,1.429-1.4,2.8,2.8,0,0,0-.478-2.371c-.124-.2-.26-.409-.392-.607a6.392,6.392,0,0,1-.872-1.633,2,2,0,0,1,.72-2.342,2.661,2.661,0,0,1,1.748-.075,5.016,5.016,0,0,0,1.025.109,2.307,2.307,0,0,0,1.693-.915,2.718,2.718,0,0,0,.576-2.167,3.391,3.391,0,0,0-2.533-2.5,1.459,1.459,0,0,1-.79,1.241.909.909,0,0,1-.853-.122.666.666,0,0,1-.3-.584.675.675,0,0,1,.246-.477,1.608,1.608,0,0,1,1.1-.3,3.57,3.57,0,0,1,.462.065,3.281,3.281,0,0,0-1.719-2.855,9.057,9.057,0,0,0-3.959-.723.071.071,0,0,1-.049-.02.069.069,0,0,1,.049-.118,9.166,9.166,0,0,1,4.023.74,3.366,3.366,0,0,1,1.792,3.008,3.541,3.541,0,0,1,2.66,2.611,2.87,2.87,0,0,1-.6,2.28,2.445,2.445,0,0,1-1.8.967,5.078,5.078,0,0,1-1.053-.111,2.532,2.532,0,0,0-1.659.061,1.859,1.859,0,0,0-.654,2.179,6.3,6.3,0,0,0,.855,1.6c.133.2.27.4.395.612a2.928,2.928,0,0,1,.49,2.49,2.813,2.813,0,0,1-1.5,1.476A4.933,4.933,0,0,1,2245.1,1115.446Zm-2.879-2.081a2.474,2.474,0,0,0,1.3-.019,1.577,1.577,0,0,0,1.1-1.16,1.106,1.106,0,0,0-.792-1.266,1.258,1.258,0,0,0-1.038.334,2.115,2.115,0,0,0-.576,2.109Zm7.194-12.611a1.38,1.38,0,0,0-.869.268.543.543,0,0,0-.2.382.532.532,0,0,0,.241.462.777.777,0,0,0,.719.106,1.325,1.325,0,0,0,.7-1.127v-.019a3.558,3.558,0,0,0-.467-.067C2249.5,1100.757,2249.46,1100.754,2249.416,1100.754Z",
  transform: "translate(-2007.157 -861.945)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1014",
  "data-name": "Path 1014",
  d: "M1544.087,903.591l-.506-.046a.207.207,0,0,1-.19-.2l-.041-2.579a.207.207,0,0,1,.131-.193l.547-.221a.208.208,0,0,1,.286.193v2.845a.207.207,0,0,1-.069.153.206.206,0,0,1-.074.043.21.21,0,0,1-.085.01Z",
  transform: "translate(-1327.959 -669.99)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1015",
  "data-name": "Path 1015",
  d: "M1541.166,900.763h-.025l-.509-.046a.277.277,0,0,1-.253-.272l-.041-2.578a.278.278,0,0,1,.173-.262l.548-.221a.278.278,0,0,1,.259.027.28.28,0,0,1,.09.1.276.276,0,0,1,.032.13v2.845a.278.278,0,0,1-.278.277Zm-.012-.139a.135.135,0,0,0,.057-.006.137.137,0,0,0,.049-.029.14.14,0,0,0,.034-.046.142.142,0,0,0,.012-.056v-2.845a.138.138,0,0,0-.016-.065.136.136,0,0,0-.045-.05.138.138,0,0,0-.129-.014l-.548.221a.138.138,0,0,0-.063.052.136.136,0,0,0-.023.079l.041,2.578a.139.139,0,0,0,.127.136Z",
  transform: "translate(-1325.019 -667.092)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1016",
  "data-name": "Path 1016",
  d: "M1626.036,871.711l-.513-.051a.208.208,0,0,1-.188-.205l-.035-3.545a.208.208,0,0,1,.127-.194l.548-.231a.209.209,0,0,1,.29.192V871.5a.208.208,0,0,1-.018.084.208.208,0,0,1-.125.113.207.207,0,0,1-.085.009Z",
  transform: "translate(-1407.957 -637.908)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1017",
  "data-name": "Path 1017",
  d: "M1623.215,868.991h-.027l-.513-.051a.278.278,0,0,1-.25-.274l-.035-3.546a.277.277,0,0,1,.169-.258l.548-.231a.277.277,0,0,1,.386.256v3.829a.277.277,0,0,1-.277.277Zm0-4.246a.138.138,0,0,0-.055.011l-.548.231a.139.139,0,0,0-.085.129l.035,3.546a.139.139,0,0,0,.125.139l.513.051a.138.138,0,0,0,.107-.036.136.136,0,0,0,.034-.046.139.139,0,0,0,.012-.056v-3.829a.138.138,0,0,0-.139-.139Z",
  transform: "translate(-1405.116 -635.118)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1018",
  "data-name": "Path 1018",
  d: "M1708.044,839.573l-.549-.057a.208.208,0,0,1-.185-.207v-4.531a.207.207,0,0,1,.127-.191l.55-.231a.208.208,0,0,1,.2.018.211.211,0,0,1,.068.075.208.208,0,0,1,.025.1v4.82a.208.208,0,0,1-.069.155.209.209,0,0,1-.075.043.214.214,0,0,1-.087.009Z",
  transform: "translate(-1488.015 -605.567)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1019",
  "data-name": "Path 1019",
  d: "M1705.157,836.825h-.029l-.55-.057a.278.278,0,0,1-.248-.277v-4.531a.277.277,0,0,1,.169-.255l.55-.231a.278.278,0,0,1,.385.256v4.819a.278.278,0,0,1-.278.277Zm0-5.238a.134.134,0,0,0-.054.012l-.55.231a.139.139,0,0,0-.085.128v4.531a.139.139,0,0,0,.124.139l.55.058a.139.139,0,0,0,.141-.082.133.133,0,0,0,.012-.056v-4.82a.139.139,0,0,0-.016-.066.137.137,0,0,0-.045-.05.135.135,0,0,0-.074-.024Z",
  transform: "translate(-1485.105 -602.748)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1020",
  "data-name": "Path 1020",
  d: "M1789.934,807.185l-.519-.054a.208.208,0,0,1-.185-.207v-5.54a.208.208,0,0,1,.13-.193l.548-.222a.208.208,0,0,1,.286.194l-.029,5.815a.211.211,0,0,1-.018.085.208.208,0,0,1-.051.07.212.212,0,0,1-.075.043.207.207,0,0,1-.086.009Z",
  transform: "translate(-1567.984 -572.978)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1021",
  "data-name": "Path 1021",
  d: "M1787.115,804.407h-.029l-.519-.054a.277.277,0,0,1-.249-.277v-5.541a.277.277,0,0,1,.173-.257l.548-.221a.277.277,0,0,1,.35.128.275.275,0,0,1,.032.131l-.029,5.814a.277.277,0,0,1-.277.277Zm-.014-.139a.138.138,0,0,0,.058-.006.139.139,0,0,0,.1-.133l.029-5.815a.14.14,0,0,0-.061-.115.139.139,0,0,0-.13-.014l-.548.221a.139.139,0,0,0-.086.128v5.54a.138.138,0,0,0,.124.139Z",
  transform: "translate(-1565.143 -570.13)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1022",
  "data-name": "Path 1022",
  d: "M1502.05,616.655c-.046,0-.09,0-.135,0-.886-.057-1.572-.659-1.526-1.341a1.466,1.466,0,0,1,1.687-1.135,1.874,1.874,0,0,1,1.107.429,1.121,1.121,0,0,1,.421.912A1.433,1.433,0,0,1,1502.05,616.655Zm-.112-2.346a1.293,1.293,0,0,0-1.413,1.009c-.039.606.588,1.142,1.4,1.194a1.33,1.33,0,0,0,1.54-1.005.978.978,0,0,0-.374-.8,1.755,1.755,0,0,0-1.025-.4c-.044,0-.086,0-.128,0Z",
  transform: "translate(-1286.018 -390.642)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1023",
  "data-name": "Path 1023",
  d: "M1706.121,629.733a1.318,1.318,0,0,1-.135,0c-.886-.057-1.572-.659-1.526-1.341a1.113,1.113,0,0,1,.535-.851,1.857,1.857,0,0,1,1.153-.283c.886.057,1.572.658,1.526,1.341A1.427,1.427,0,0,1,1706.121,629.733Zm-.113-2.347a1.7,1.7,0,0,0-.939.265.976.976,0,0,0-.472.744c-.04.607.588,1.142,1.4,1.194a1.329,1.329,0,0,0,1.539-1.005c.039-.606-.588-1.143-1.4-1.194-.043,0-.085,0-.128,0Z",
  transform: "translate(-1485.23 -403.408)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1024",
  "data-name": "Path 1024",
  d: "M1922.982,643.666c-.046,0-.089,0-.135,0a1.873,1.873,0,0,1-1.106-.429,1.12,1.12,0,0,1-.421-.912,1.465,1.465,0,0,1,1.687-1.135,1.878,1.878,0,0,1,1.107.429,1.124,1.124,0,0,1,.421.913A1.428,1.428,0,0,1,1922.982,643.666Zm-.111-2.346a1.293,1.293,0,0,0-1.413,1.009.975.975,0,0,0,.374.8,1.758,1.758,0,0,0,1.025.4,1.329,1.329,0,0,0,1.539-1.006.976.976,0,0,0-.374-.8,1.751,1.751,0,0,0-1.025-.4C1922.955,641.322,1922.913,641.32,1922.871,641.32Z",
  transform: "translate(-1696.927 -417.01)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1025",
  "data-name": "Path 1025",
  d: "M1660.4,377.359h-.041l-4.161-.268a.626.626,0,0,1-.43-.211.626.626,0,0,1-.155-.453l.129-2.01a.625.625,0,0,1,.663-.583l4.161.268a.623.623,0,0,1,.583.663l-.126,2.01a.626.626,0,0,1-.623.584Zm-4.035-3.387a.486.486,0,0,0-.484.455l-.129,2.01a.486.486,0,0,0,.453.516l4.161.268a.486.486,0,0,0,.516-.453l.129-2.01a.486.486,0,0,0-.451-.516l-4.161-.268Z",
  transform: "translate(-1437.552 -156.028)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1026",
  "data-name": "Path 1026",
  d: "M1568.985,517.091a.066.066,0,0,1-.021,0,.068.068,0,0,1-.024-.013.07.07,0,0,1-.022-.074,3.049,3.049,0,0,1,1.676-1.862.069.069,0,0,1,.091.036.07.07,0,0,1-.036.091,2.9,2.9,0,0,0-1.6,1.776.072.072,0,0,1-.025.035.071.071,0,0,1-.041.014Z",
  transform: "translate(-1352.915 -293.963)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1027",
  "data-name": "Path 1027",
  d: "M1770.635,543.146h0a.07.07,0,0,1-.048-.023.069.069,0,0,1-.018-.05l.095-1.561a.075.075,0,0,1,.007-.026.069.069,0,0,1,.067-.039.07.07,0,0,1,.026.007.069.069,0,0,1,.035.04.067.067,0,0,1,0,.027l-.095,1.561a.071.071,0,0,1-.021.046.068.068,0,0,1-.048.019Z",
  transform: "translate(-1549.765 -319.649)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1028",
  "data-name": "Path 1028",
  d: "M1889.794,525.269a.069.069,0,0,1-.066-.049,3.913,3.913,0,0,0-1.757-2.205.072.072,0,0,1-.02-.018.073.073,0,0,1-.012-.024.07.07,0,0,1,0-.027.069.069,0,0,1,.009-.026.067.067,0,0,1,.018-.02.069.069,0,0,1,.024-.012.072.072,0,0,1,.027,0,.07.07,0,0,1,.026.009,4.055,4.055,0,0,1,1.821,2.285.07.07,0,0,1-.005.053.069.069,0,0,1-.041.034.065.065,0,0,1-.021,0Z",
  transform: "translate(-1664.34 -301.53)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1029",
  "data-name": "Path 1029",
  d: "M1291.736,318.212h4.316a32.163,32.163,0,0,1-.576,6.066,19.476,19.476,0,0,0-5.1-.681A10.209,10.209,0,0,0,1291.736,318.212Z",
  transform: "translate(-1081.012 -101.73)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1030",
  "data-name": "Path 1030",
  d: "M1292.634,321.5l-.019,0a19.559,19.559,0,0,0-5.074-.678.07.07,0,0,1-.064-.036.07.07,0,0,1-.009-.037.071.071,0,0,1,.012-.036,10.246,10.246,0,0,0,1.344-5.346.069.069,0,0,1,.069-.069h4.316a.069.069,0,0,1,.049.02.07.07,0,0,1,.021.048,32.556,32.556,0,0,1-.577,6.08.068.068,0,0,1-.032.046A.071.071,0,0,1,1292.634,321.5Zm-4.629-.832a20.842,20.842,0,0,1,4.578.676,32.336,32.336,0,0,0,.559-5.91h-4.18a10.742,10.742,0,0,1-1.295,5.24c.111,0,.224-.006.337-.006Z",
  transform: "translate(-1078.169 -98.887)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1031",
  "data-name": "Path 1031",
  d: "M2367.867,750.2s3.7-.164,5.179,0a10.113,10.113,0,0,0,.617,5.092,37.911,37.911,0,0,0-5.446.375A17.386,17.386,0,0,1,2367.867,750.2Z",
  transform: "translate(-2132.771 -523.365)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1032",
  "data-name": "Path 1032",
  d: "M2365.405,752.921a.07.07,0,0,1-.067-.052,17.608,17.608,0,0,1-.351-5.491.07.07,0,0,1,.066-.063c.037,0,3.721-.163,5.189,0a.07.07,0,0,1,.026.009.074.074,0,0,1,.02.019.072.072,0,0,1,.012.026.069.069,0,0,1,0,.028,10.146,10.146,0,0,0,.614,5.054.069.069,0,0,1,0,.033.068.068,0,0,1-.012.031.069.069,0,0,1-.025.022.067.067,0,0,1-.032.008,38.076,38.076,0,0,0-5.432.373Zm-.286-5.469a17.649,17.649,0,0,0,.337,5.317,37.447,37.447,0,0,1,5.294-.362,10.423,10.423,0,0,1-.6-4.962c-1.4-.137-4.559-.013-5.035.006Z",
  transform: "translate(-2129.959 -520.546)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1033",
  "data-name": "Path 1033",
  d: "M2431.616,799.632a.069.069,0,0,1-.074-.064.069.069,0,0,1,.064-.074,11.931,11.931,0,0,1,2.607-.1.07.07,0,0,1,.048.024.068.068,0,0,1,.017.051.075.075,0,0,1-.007.026.068.068,0,0,1-.017.021.069.069,0,0,1-.05.017,11.74,11.74,0,0,0-2.577.1Z",
  transform: "translate(-2195.001 -571.427)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1034",
  "data-name": "Path 1034",
  d: "M2436.858,849.878a.07.07,0,0,1-.01-.139,11.758,11.758,0,0,1,2.482-.115.069.069,0,0,1,.026.007.073.073,0,0,1,.021.016.07.07,0,0,1,.017.05.07.07,0,0,1-.007.026.071.071,0,0,1-.016.022.074.074,0,0,1-.024.014.07.07,0,0,1-.027,0,11.608,11.608,0,0,0-2.451.113Z",
  transform: "translate(-2200.119 -620.47)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1035",
  "data-name": "Path 1035",
  d: "M2450.667,898.414a.07.07,0,0,1-.076-.062.069.069,0,0,1,.014-.051.07.07,0,0,1,.046-.026,3.686,3.686,0,0,1,1.131-.084.07.07,0,0,1,.048.024.07.07,0,0,1-.008.1.07.07,0,0,1-.051.016,3.528,3.528,0,0,0-1.088.081l-.016,0Z",
  transform: "translate(-2213.597 -667.889)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1036",
  "data-name": "Path 1036",
  d: "M1381.321,368.957h-2.3a.068.068,0,0,1-.049-.02.069.069,0,0,1,0-.1.068.068,0,0,1,.049-.02h2.3a.069.069,0,0,1,0,.139Z",
  transform: "translate(-1167.473 -151.132)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1037",
  "data-name": "Path 1037",
  d: "M1367.857,424.077l-2.589-.049a.069.069,0,0,1-.026-.006.067.067,0,0,1-.022-.015.069.069,0,0,1-.015-.023.073.073,0,0,1,0-.027.069.069,0,0,1,.021-.049.066.066,0,0,1,.023-.015.069.069,0,0,1,.026,0l2.589.049a.07.07,0,0,1,.049.02.069.069,0,0,1,0,.1.07.07,0,0,1-.049.02Z",
  transform: "translate(-1154.051 -204.891)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1038",
  "data-name": "Path 1038",
  d: "M1374.272,473.856h0l-2.136-.1a.069.069,0,0,1,.006-.139l2.137.1a.069.069,0,0,1,.049.021.069.069,0,0,1,0,.1.07.07,0,0,1-.05.019Z",
  transform: "translate(-1160.753 -253.436)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1039",
  "data-name": "Path 1039",
  d: "M1387.2,517.117l-1.192-.033a.07.07,0,0,1-.049-.022.073.073,0,0,1-.014-.023.071.071,0,0,1,0-.027.07.07,0,0,1,.071-.068l1.192.034a.069.069,0,1,1,0,.139Z",
  transform: "translate(-1174.296 -295.731)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1040",
  "data-name": "Path 1040",
  d: "M1859.971,1000.125h-.009l-1.026-.139a.07.07,0,0,1-.06-.078.069.069,0,0,1,.027-.046.07.07,0,0,1,.052-.014l1.026.139a.069.069,0,1,1-.009.139Z",
  transform: "translate(-1635.971 -767.135)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1041",
  "data-name": "Path 1041",
  d: "M1945.926,1011.207h-.011l-.781-.122a.07.07,0,0,1-.046-.028.069.069,0,0,1-.013-.052.07.07,0,0,1,.028-.046.069.069,0,0,1,.052-.013l.781.123a.07.07,0,0,1,.04.122.069.069,0,0,1-.051.016Z",
  transform: "translate(-1720.118 -777.969)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1042",
  "data-name": "Path 1042",
  d: "M2017.128,1019.429h0l-1.151-.04a.069.069,0,0,1-.045-.12.071.071,0,0,1,.05-.019l1.153.04a.07.07,0,0,1,.048.022.069.069,0,0,1,.014.023.074.074,0,0,1,0,.027.066.066,0,0,1-.006.026.069.069,0,0,1-.016.022.065.065,0,0,1-.023.014.071.071,0,0,1-.026,0Z",
  transform: "translate(-1789.264 -786.076)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1043",
  "data-name": "Path 1043",
  d: "M2101.26,1023.747a4.156,4.156,0,0,1-.846-.086.069.069,0,0,1-.044-.03.071.071,0,0,1-.01-.025.068.068,0,0,1,0-.027.066.066,0,0,1,.01-.025.067.067,0,0,1,.019-.019.068.068,0,0,1,.025-.01.07.07,0,0,1,.027,0,4.038,4.038,0,0,0,1.215.064.07.07,0,0,1,.051.016.069.069,0,0,1,.025.047.069.069,0,0,1-.016.051.07.07,0,0,1-.047.025C2101.534,1023.74,2101.4,1023.747,2101.26,1023.747Z",
  transform: "translate(-1871.704 -790.248)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1044",
  "data-name": "Path 1044",
  d: "M2188.57,999.478a.069.069,0,0,1-.049-.02.069.069,0,0,1,0-.1.069.069,0,0,1,.049-.02,1.083,1.083,0,0,0,.961-.627.068.068,0,0,1,.016-.023.066.066,0,0,1,.023-.015.07.07,0,0,1,.054,0,.075.075,0,0,1,.022.016.07.07,0,0,1,.014.023.065.065,0,0,1,0,.027.067.067,0,0,1-.007.026,1.227,1.227,0,0,1-1.087.709Z",
  transform: "translate(-1957.747 -765.986)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M2242.652,915.564h-.012a.069.069,0,0,1-.025-.01.069.069,0,0,1-.031-.043.077.077,0,0,1,0-.027l.2-1.153a.07.07,0,0,1,.139.023l-.195,1.153a.073.073,0,0,1-.025.041.071.071,0,0,1-.045.016Z",
  transform: "translate(-2010.542 -683.598)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M2250.709,820.583a.068.068,0,0,1-.049-.02.069.069,0,0,1-.021-.049V819.4a.069.069,0,0,1,.139,0v1.11a.07.07,0,0,1-.069.069Z",
  transform: "translate(-2018.407 -590.921)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1047",
  "data-name": "Path 1047",
  d: "M2223.316,787.512a.07.07,0,0,1-.055-.027,4.883,4.883,0,0,1-.733-1.356l-.667,1.273a.067.067,0,0,1-.017.021.072.072,0,0,1-.024.013.069.069,0,0,1-.027,0,.069.069,0,0,1-.06-.048.072.072,0,0,1,0-.027.069.069,0,0,1,.008-.026l.743-1.418a.069.069,0,0,1,.028-.029.069.069,0,0,1,.077.007.071.071,0,0,1,.023.033,4.736,4.736,0,0,0,.763,1.469.069.069,0,0,1,.014.035.071.071,0,0,1-.007.037.069.069,0,0,1-.062.039Z",
  transform: "translate(-1990.186 -558.266)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1048",
  "data-name": "Path 1048",
  d: "M1651.955,316.544h0l-20.92-1.11a.069.069,0,0,1-.026-.007.07.07,0,0,1-.022-.016.071.071,0,0,1-.014-.023.069.069,0,0,1,0-.027.07.07,0,0,1,.007-.026.072.072,0,0,1,.016-.022.07.07,0,0,1,.05-.018l20.92,1.11a.069.069,0,0,1,.049.022.071.071,0,0,1,.015.023.073.073,0,0,1,0,.027.073.073,0,0,1-.006.026.069.069,0,0,1-.039.037.07.07,0,0,1-.027,0Z",
  transform: "translate(-1413.488 -98.884)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1049",
  "data-name": "Path 1049",
  d: "M2302.821,292.644a.4.4,0,1,0-.4-.4A.4.4,0,0,0,2302.821,292.644Z",
  transform: "translate(-2068.954 -75.988)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1050",
  "data-name": "Path 1050",
  d: "M2299.972,289.869a.47.47,0,1,1,.333-.138.47.47,0,0,1-.333.138Zm0-.8a.332.332,0,1,0,.332.332.331.331,0,0,0-.1-.236.331.331,0,0,0-.235-.1Z",
  transform: "translate(-2066.106 -73.144)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1051",
  "data-name": "Path 1051",
  d: "M2386.451,297.285a.4.4,0,1,0-.4-.4A.4.4,0,0,0,2386.451,297.285Z",
  transform: "translate(-2150.593 -80.519)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1052",
  "data-name": "Path 1052",
  d: "M2383.683,294.491a.47.47,0,1,1,.436-.29.47.47,0,0,1-.436.29Zm0-.8a.332.332,0,1,0,.234.1.332.332,0,0,0-.234-.1Z",
  transform: "translate(-2147.826 -77.656)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1053",
  "data-name": "Path 1053",
  d: "M2470.671,301.751a.4.4,0,1,0-.4-.4A.4.4,0,0,0,2470.671,301.751Z",
  transform: "translate(-2232.808 -84.879)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1054",
  "data-name": "Path 1054",
  d: "M2467.832,298.977a.471.471,0,1,1,.332-.138.47.47,0,0,1-.332.138Zm0-.8a.332.332,0,1,0,.234.1.332.332,0,0,0-.234-.1Z",
  transform: "translate(-2229.969 -82.035)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1055",
  "data-name": "Path 1055",
  d: "M2114.4,490.991a3.243,3.243,0,1,0-4.14,1.515A3.122,3.122,0,0,0,2114.4,490.991Z",
  transform: "translate(-1879.374 -266.215)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1056",
  "data-name": "Path 1056",
  d: "M2108.64,489.921a3.5,3.5,0,0,1-1.352-.274,3.416,3.416,0,0,1-1.807-1.727,2.913,2.913,0,0,1,1.675-4,3.415,3.415,0,0,1,2.5.074,3.194,3.194,0,0,1,1.864,4.1A3.065,3.065,0,0,1,2108.64,489.921Zm-.341-6.067a3.179,3.179,0,0,0-1.1.193,2.774,2.774,0,0,0-1.6,3.816,3.278,3.278,0,0,0,1.734,1.657,2.936,2.936,0,1,0,2.26-5.4,3.376,3.376,0,0,0-1.3-.265Z",
  transform: "translate(-1876.432 -263.293)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1057",
  "data-name": "Path 1057",
  d: "M615.019,1950.175a.069.069,0,0,1-.028-.006c-.06-.026-6-2.595-8.022-3.2a.068.068,0,0,1-.031-.019.071.071,0,0,1-.017-.033.069.069,0,0,1,.023-.067l2.017-1.748a23.268,23.268,0,0,1-5.47-1.45,10.738,10.738,0,0,1-3.775-2.454,5.355,5.355,0,0,1-1.506-4.165.069.069,0,0,1,.037-.057,31.855,31.855,0,0,1,10.966-2.945,28.886,28.886,0,0,1,10.81,1.055,29.49,29.49,0,0,1,11.785,6.946.063.063,0,0,1,.017.024.068.068,0,0,1,.005.029.069.069,0,0,1-.026.051l-7.713,6.175a.067.067,0,0,1-.036.015.069.069,0,0,1-.038-.007,53.863,53.863,0,0,0-4.961-2.2c-.261.277-2.295,2.439-3.988,4.042a.069.069,0,0,1-.048.02Zm-7.89-3.305c2.041.641,7.347,2.926,7.875,3.154,1.794-1.7,3.955-4.012,3.976-4.035a.07.07,0,0,1,.031-.019.071.071,0,0,1,.036,0,49.176,49.176,0,0,1,4.989,2.205l7.616-6.1a28.439,28.439,0,0,0-22.428-7.91,31.841,31.841,0,0,0-10.88,2.913c-.226,3.437,2.7,5.4,5.2,6.441a23.056,23.056,0,0,0,5.59,1.46.069.069,0,0,1,.06.088.071.071,0,0,1-.022.033Z",
  transform: "translate(-405.308 -1678.96)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1058",
  "data-name": "Path 1058",
  d: "M601.115,1939.859s18.013-9.514,33.481,5.046l-7.713,6.175a51.59,51.59,0,0,0-5.014-2.219s-2.19,2.343-4.013,4.069c0,0-5.976-2.589-8.03-3.206l2.135-1.85S600.624,1946.641,601.115,1939.859Z",
  transform: "translate(-408.144 -1681.784)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1059",
  "data-name": "Path 1059",
  d: "M1212.895,1938.084a6.708,6.708,0,0,1-1.146-.1c-2.212-.386-3.824-1.779-3.593-3.106a1.508,1.508,0,0,1,.075-.272.071.071,0,0,1,.026-.034.073.073,0,0,1,.041-.012,28.111,28.111,0,0,1,7.856,1.38.071.071,0,0,1,.034.026.069.069,0,0,1,.013.04,1.441,1.441,0,0,1-.022.27,2.107,2.107,0,0,1-1.487,1.506A5.073,5.073,0,0,1,1212.895,1938.084Zm-4.6-3.183c-.218,1.252,1.344,2.573,3.481,2.945a5.568,5.568,0,0,0,2.872-.2,1.978,1.978,0,0,0,1.4-1.4,1.335,1.335,0,0,0,.019-.2,27.989,27.989,0,0,0-7.722-1.355,1.369,1.369,0,0,0-.052.2Z",
  transform: "translate(-1000.724 -1679.591)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1060",
  "data-name": "Path 1060",
  d: "M1182.209,1969.973a.071.071,0,0,1-.045-.017.07.07,0,0,1-.022-.043.068.068,0,0,1,.01-.047.069.069,0,0,1,.039-.029l1.043-.3a.069.069,0,0,1,.038.134l-1.045.3-.017,0Z",
  transform: "translate(-975.35 -1713.738)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1061",
  "data-name": "Path 1061",
  d: "M1217.837,2011.818a.066.066,0,0,1-.038-.012.069.069,0,0,1-.03-.044.07.07,0,0,1,.01-.052,2.057,2.057,0,0,1,.8-.706.07.07,0,0,1,.1.084.071.071,0,0,1-.035.04,1.912,1.912,0,0,0-.743.657.069.069,0,0,1-.025.024.072.072,0,0,1-.033.008Z",
  transform: "translate(-1010.128 -1754.208)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1062",
  "data-name": "Path 1062",
  d: "M1288.633,2051.847h-.013a.072.072,0,0,1-.044-.029.07.07,0,0,1-.01-.052,4.445,4.445,0,0,1,.551-1.44.069.069,0,0,1,.1-.024.068.068,0,0,1,.032.042.069.069,0,0,1-.008.053,4.316,4.316,0,0,0-.535,1.4.069.069,0,0,1-.024.04A.069.069,0,0,1,1288.633,2051.847Z",
  transform: "translate(-1079.239 -1792.568)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1063",
  "data-name": "Path 1063",
  d: "M1412.01,2066.717a.068.068,0,0,1-.038-.012.069.069,0,0,1-.026-.03l-.272-.631a.069.069,0,0,1,.036-.091.07.07,0,0,1,.053,0,.069.069,0,0,1,.038.037l.271.631a.068.068,0,0,1,.006.027.064.064,0,0,1,0,.027.069.069,0,0,1-.037.039.072.072,0,0,1-.028,0Z",
  transform: "translate(-1199.414 -1807.851)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1064",
  "data-name": "Path 1064",
  d: "M1505.536,2022.1a.072.072,0,0,1-.029-.006.068.068,0,0,1-.024-.018,2.263,2.263,0,0,0-1.278-.753.066.066,0,0,1-.026-.01.071.071,0,0,1-.02-.019.068.068,0,0,1-.011-.025.076.076,0,0,1,0-.028.069.069,0,0,1,.011-.025.071.071,0,0,1,.02-.019.075.075,0,0,1,.026-.01.07.07,0,0,1,.028,0,2.4,2.4,0,0,1,1.356.8.073.073,0,0,1,.013.024.067.067,0,0,1,0,.027.067.067,0,0,1-.025.047.068.068,0,0,1-.044.017Z",
  transform: "translate(-1289.69 -1764.156)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1065",
  "data-name": "Path 1065",
  d: "M1479.537,2051.842a.051.051,0,0,1-.02,0,.049.049,0,0,1-.016-.013l-.583-.733a.046.046,0,0,1-.01-.034.046.046,0,0,1,.017-.031.047.047,0,0,1,.065.008l.583.734a.044.044,0,0,1,.01.024.045.045,0,0,1,0,.025.046.046,0,0,1-.017.019.045.045,0,0,1-.025.007Z",
  transform: "translate(-1265.05 -1793.275)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1066",
  "data-name": "Path 1066",
  d: "M1363.662,2065.4a.045.045,0,0,1-.032-.013.046.046,0,0,1-.014-.033l-.027-.548a.047.047,0,0,1,.012-.033.046.046,0,0,1,.032-.015.048.048,0,0,1,.033.012.047.047,0,0,1,.015.032l.026.548a.047.047,0,0,1-.013.032.046.046,0,0,1-.031.014Z",
  transform: "translate(-1152.478 -1806.69)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1067",
  "data-name": "Path 1067",
  d: "M1893.256,2271.887a.046.046,0,0,1-.026-.008.047.047,0,0,1-.017-.021.048.048,0,0,1,0-.028.048.048,0,0,1,.014-.024l1.066-.99a.046.046,0,0,1,.032-.01.047.047,0,0,1,.031.015.046.046,0,0,1,.012.031.046.046,0,0,1-.013.032l-1.063.99a.045.045,0,0,1-.016.01A.044.044,0,0,1,1893.256,2271.887Z",
  transform: "translate(-1669.487 -2007.832)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1068",
  "data-name": "Path 1068",
  d: "M1665.926,2430.257a.047.047,0,0,1-.033-.014.046.046,0,0,1,0-.065l.885-.9a.044.044,0,0,1,.015-.012.051.051,0,0,1,.018,0,.049.049,0,0,1,.019,0,.053.053,0,0,1,.016.01.045.045,0,0,1,.01.016.044.044,0,0,1,0,.037.04.04,0,0,1-.011.015l-.884.9a.045.045,0,0,1-.015.01.05.05,0,0,1-.019,0Z",
  transform: "translate(-1447.571 -2162.518)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1069",
  "data-name": "Path 1069",
  d: "M1674.555,2429.868a.048.048,0,0,1-.024-.007.046.046,0,0,1-.017-.019.045.045,0,0,1,0-.025.047.047,0,0,1,.009-.023l.192-.247a.043.043,0,0,1,.014-.013.044.044,0,0,1,.017-.007.041.041,0,0,1,.019,0,.046.046,0,0,1,.017.008.05.05,0,0,1,.012.015.041.041,0,0,1,.005.018.047.047,0,0,1,0,.019.046.046,0,0,1-.009.017l-.192.247a.043.043,0,0,1-.016.013A.052.052,0,0,1,1674.555,2429.868Z",
  transform: "translate(-1455.995 -2162.773)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1070",
  "data-name": "Path 1070",
  d: "M829.825,2030.012a.07.07,0,0,1-.044-.016.068.068,0,0,1-.024-.04.07.07,0,0,1,.007-.046.069.069,0,0,1,.035-.031,5.03,5.03,0,0,1,1.341-.34.072.072,0,0,1,.027,0,.073.073,0,0,1,.024.013.071.071,0,0,1,.018.021.07.07,0,0,1,.006.053.067.067,0,0,1-.013.024.071.071,0,0,1-.021.018.07.07,0,0,1-.026.008,4.91,4.91,0,0,0-1.3.331.072.072,0,0,1-.026,0Z",
  transform: "translate(-631.355 -1772.309)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1071",
  "data-name": "Path 1071",
  d: "M867.719,2052.533a.071.071,0,0,1-.052-.014.07.07,0,0,1-.012-.1.071.071,0,0,1,.047-.026l.329-.082a.071.071,0,0,1,.051.01.07.07,0,0,1,.023.093.071.071,0,0,1-.041.032l-.329.082a.044.044,0,0,1-.017,0Z",
  transform: "translate(-668.339 -1794.539)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1072",
  "data-name": "Path 1072",
  d: "M677.6,2389.97a17.176,17.176,0,0,1,.584,5.647h.505a17.809,17.809,0,0,0-.545-5.647Z",
  transform: "translate(-482.825 -2124.158)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1073",
  "data-name": "Path 1073",
  d: "M675.91,2392.806h-.5a.067.067,0,0,1-.028-.006.064.064,0,0,1-.023-.017.07.07,0,0,1-.014-.025.07.07,0,0,1,0-.029,17.3,17.3,0,0,0-.582-5.62.07.07,0,0,1,0-.032.068.068,0,0,1,.013-.029.07.07,0,0,1,.024-.02.068.068,0,0,1,.031-.007h.545a.069.069,0,0,1,.066.049,18.019,18.019,0,0,1,.547,5.672.07.07,0,0,1-.07.064Zm-.428-.139h.363a17.818,17.818,0,0,0-.531-5.509h-.4A17.346,17.346,0,0,1,675.482,2392.667Z",
  transform: "translate(-480.044 -2121.278)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1074",
  "data-name": "Path 1074",
  d: "M306.688,1170.542a7.441,7.441,0,0,0-6.227,1.55,23.339,23.339,0,0,0-6.9,12.022l7.338,7.583a33.579,33.579,0,0,1,10.046-2.847,8.376,8.376,0,0,0,1.6-3.792s4.254,3.8,8.693,2.61,11.236-6.018,11.236-6.018a12.9,12.9,0,0,0-6.242-5l-3.267,1.233a4.319,4.319,0,0,0-1.973-2.358,36.4,36.4,0,0,0-4.589,1.128A12.637,12.637,0,0,0,306.688,1170.542Z",
  transform: "translate(-107.923 -933.622)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1075",
  "data-name": "Path 1075",
  d: "M367.421,1531.653a.07.07,0,0,1-.038-.011.067.067,0,0,1-.025-.031,49.275,49.275,0,0,1-1.668-4.991.07.07,0,0,1,0-.028.068.068,0,0,1,.008-.027.065.065,0,0,1,.018-.021.071.071,0,0,1,.025-.013.067.067,0,0,1,.028,0,.072.072,0,0,1,.026.009.074.074,0,0,1,.02.019.07.07,0,0,1,.011.026,48.742,48.742,0,0,0,1.661,4.973.071.071,0,0,1,.006.027.07.07,0,0,1-.02.05.071.071,0,0,1-.023.016.077.077,0,0,1-.028,0Z",
  transform: "translate(-178.336 -1281.277)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1076",
  "data-name": "Path 1076",
  d: "M476.766,1368.2a.066.066,0,0,1-.036-.01.068.068,0,0,1-.025-.027c-1.66-3.168-4.8-12.09-4.833-12.18a.07.07,0,0,1,0-.053.07.07,0,0,1,.04-.036.069.069,0,0,1,.089.042c.032.09,3.169,9,4.825,12.161a.07.07,0,0,1-.029.093.074.074,0,0,1-.032.01Z",
  transform: "translate(-281.989 -1114.704)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1077",
  "data-name": "Path 1077",
  d: "M634.318,1223.3a.069.069,0,0,1-.036-.01.067.067,0,0,1-.025-.028c-1.13-2.269-7.125-17.646-7.186-17.8a.067.067,0,0,1-.006-.027.069.069,0,0,1,.021-.051.066.066,0,0,1,.023-.015.068.068,0,0,1,.055,0,.064.064,0,0,1,.022.017.071.071,0,0,1,.014.024c.061.155,6.053,15.525,7.181,17.789a.07.07,0,0,1,0,.053.071.071,0,0,1-.035.04.072.072,0,0,1-.031.009Z",
  transform: "translate(-433.491 -967.754)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1078",
  "data-name": "Path 1078",
  d: "M1213.456,1385.582a.071.071,0,0,1-.065-.046c-.791-2.141-5.173-12.414-5.217-12.517a.069.069,0,0,1,.089-.089.068.068,0,0,1,.038.035c.046.1,4.427,10.379,5.22,12.523a.07.07,0,0,1-.041.089.066.066,0,0,1-.024.005Z",
  transform: "translate(-1000.759 -1131.329)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1079",
  "data-name": "Path 1079",
  d: "M1432.851,1395.876a.069.069,0,0,1-.057-.029c-.915-1.263-5.509-9.88-5.555-9.966a.07.07,0,0,1-.009-.026.066.066,0,0,1,0-.028.07.07,0,0,1,.088-.047.07.07,0,0,1,.024.014.067.067,0,0,1,.017.022c.046.087,4.636,8.693,5.546,9.951a.067.067,0,0,1,.013.035.07.07,0,0,1-.007.037.071.071,0,0,1-.061.038Z",
  transform: "translate(-1214.603 -1143.875)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1080",
  "data-name": "Path 1080",
  d: "M1727.948,1463.969a.07.07,0,0,1-.059-.033l-3.278-5.34a.069.069,0,0,1-.008-.052.071.071,0,0,1,.031-.043.069.069,0,0,1,.052-.008.071.071,0,0,1,.043.031l3.278,5.34a.07.07,0,0,1,.008.052.069.069,0,0,1-.031.043.067.067,0,0,1-.036.01Z",
  transform: "translate(-1504.894 -1214.858)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1081",
  "data-name": "Path 1081",
  d: "M452.508,1193.447a.068.068,0,0,1-.06-.035c-2.437-4.232-6-14.352-6.341-15.31-3.4,1.569-10.318,5.141-10.388,5.179a.07.07,0,0,1-.064-.124c.071-.036,7.089-3.659,10.463-5.212a.073.073,0,0,1,.056,0,.069.069,0,0,1,.023.016.072.072,0,0,1,.015.025c.038.109,3.815,10.947,6.355,15.359a.07.07,0,0,1,.005.051.069.069,0,0,1-.031.041.072.072,0,0,1-.035.01Z",
  transform: "translate(-246.603 -940.987)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1082",
  "data-name": "Path 1082",
  d: "M417.616,1267.314a.069.069,0,0,1-.034-.009.067.067,0,0,1-.025-.025.069.069,0,0,1,.025-.092c.116-.068,11.633-6.83,15.871-9.348a.069.069,0,0,1,.053-.008.069.069,0,0,1,.019.127c-4.24,2.518-15.757,9.281-15.872,9.348a.066.066,0,0,1-.035.007Z",
  transform: "translate(-228.963 -1018.975)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1083",
  "data-name": "Path 1083",
  d: "M647.168,1437.406a.071.071,0,0,1-.042-.015.07.07,0,0,1-.024-.038.069.069,0,0,1,0-.045.071.071,0,0,1,.031-.033c.123-.065,12.343-6.526,14.422-7.871a.072.072,0,0,1,.025-.01.068.068,0,0,1,.027,0,.07.07,0,0,1,.025.011.073.073,0,0,1,.019.019.07.07,0,0,1,.01.025.07.07,0,0,1-.011.052.07.07,0,0,1-.019.019c-2.084,1.348-14.309,7.809-14.432,7.877a.069.069,0,0,1-.032.008Z",
  transform: "translate(-453.048 -1186.453)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1084",
  "data-name": "Path 1084",
  d: "M721.947,1442.895a.069.069,0,0,1-.067-.052.069.069,0,0,1,.033-.078l22.406-12.443a.068.068,0,0,1,.026-.008.072.072,0,0,1,.027,0,.067.067,0,0,1,.024.013.066.066,0,0,1,.018.021.071.071,0,0,1,.008.026.07.07,0,0,1-.015.051.071.071,0,0,1-.021.018l-22.406,12.443a.071.071,0,0,1-.034.009Z",
  transform: "translate(-526.046 -1187.351)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1085",
  "data-name": "Path 1085",
  d: "M1291.621,1582.38a.071.071,0,0,1-.043-.014.069.069,0,0,1-.025-.038.07.07,0,0,1,0-.045.07.07,0,0,1,.031-.033l13.872-7.537a.067.067,0,0,1,.026-.008.071.071,0,0,1,.027,0,.074.074,0,0,1,.024.013.069.069,0,0,1,.017.021.065.065,0,0,1,.008.026.067.067,0,0,1,0,.027.074.074,0,0,1-.013.024.068.068,0,0,1-.021.017l-13.871,7.537A.063.063,0,0,1,1291.621,1582.38Z",
  transform: "translate(-1082.156 -1328.305)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1086",
  "data-name": "Path 1086",
  d: "M910.388,1653.419a.072.072,0,0,1-.05-.02c-2.814-2.856-3.72-3.2-4.28-3.148a.069.069,0,0,1-.051-.015.07.07,0,0,1-.009-.1.07.07,0,0,1,.047-.025c.686-.066,1.7.452,4.393,3.19a.069.069,0,0,1,0,.1.068.068,0,0,1-.023.014.067.067,0,0,1-.027,0Z",
  transform: "translate(-705.768 -1401.912)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1087",
  "data-name": "Path 1087",
  d: "M1038.6,1292.6a.069.069,0,0,1-.021,0,.075.075,0,0,1-.024-.013.068.068,0,0,1-.017-.021.067.067,0,0,1-.008-.026.065.065,0,0,1,0-.027,4.951,4.951,0,0,1,1.134-1.915.07.07,0,0,1,.049-.021.069.069,0,0,1,.051.117,4.805,4.805,0,0,0-1.1,1.861.069.069,0,0,1-.025.035.069.069,0,0,1-.04.014Z",
  transform: "translate(-835.154 -1050.935)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1088",
  "data-name": "Path 1088",
  d: "M1056.178,1338.256h-.017a.07.07,0,0,1-.05-.084,2.4,2.4,0,0,1,.509-.975.072.072,0,0,1,.022-.017.069.069,0,0,1,.026-.007.068.068,0,0,1,.027,0,.07.07,0,0,1,.04.036.071.071,0,0,1,.007.026.073.073,0,0,1,0,.027.07.07,0,0,1-.014.024,2.258,2.258,0,0,0-.478.919.068.068,0,0,1-.026.036A.07.07,0,0,1,1056.178,1338.256Z",
  transform: "translate(-852.319 -1096.428)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1089",
  "data-name": "Path 1089",
  d: "M866.16,1682.328a.068.068,0,0,1-.034-.009.067.067,0,0,1-.025-.024.07.07,0,0,1,.022-.1,2.349,2.349,0,0,1,1.53-.324.07.07,0,0,1,.06.079.07.07,0,0,1-.079.06,2.208,2.208,0,0,0-1.438.307.067.067,0,0,1-.036.007Z",
  transform: "translate(-666.826 -1432.905)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1090",
  "data-name": "Path 1090",
  d: "M1334.087,1824.236a2.13,2.13,0,0,1-1.332-.458.073.073,0,0,1-.019-.021.07.07,0,0,1-.01-.027.078.078,0,0,1,0-.028.067.067,0,0,1,.013-.025.069.069,0,0,1,.049-.025.072.072,0,0,1,.028,0,.068.068,0,0,1,.024.015,2,2,0,0,0,1.973.286.068.068,0,0,1,.027-.006.069.069,0,0,1,.027,0,.067.067,0,0,1,.023.015.069.069,0,0,1,.016.022.073.073,0,0,1,.005.027.069.069,0,0,1-.005.027.071.071,0,0,1-.016.022.068.068,0,0,1-.023.015,2.044,2.044,0,0,1-.782.152Z",
  transform: "translate(-1122.35 -1571.324)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1091",
  "data-name": "Path 1091",
  d: "M1420.257,1683.13a.074.074,0,0,1-.037-.011,6.621,6.621,0,0,0-1.5-.7.07.07,0,0,1-.041-.034.068.068,0,0,1,0-.053.069.069,0,0,1,.034-.041.071.071,0,0,1,.053,0,6.785,6.785,0,0,1,1.534.71.07.07,0,0,1,.02.019.067.067,0,0,1,.011.025.064.064,0,0,1,0,.027.062.062,0,0,1-.01.025.067.067,0,0,1-.025.025.071.071,0,0,1-.034.009Z",
  transform: "translate(-1206.247 -1433.325)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1092",
  "data-name": "Path 1092",
  d: "M1357.978,1818.163h-.01l-.575-.124a.051.051,0,0,1-.018-.006.05.05,0,0,1-.014-.013.046.046,0,0,1-.008-.017.042.042,0,0,1,0-.019.051.051,0,0,1,.008-.017.049.049,0,0,1,.032-.019.045.045,0,0,1,.019,0l.575.124a.045.045,0,0,1,.031.017.046.046,0,0,1,.01.034.047.047,0,0,1-.017.031.046.046,0,0,1-.034.01Z",
  transform: "translate(-1146.391 -1565.755)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1093",
  "data-name": "Path 1093",
  d: "M1808.617,1539.309a.047.047,0,0,1-.022-.005.046.046,0,0,1-.017-.015,2.541,2.541,0,0,0-.69-.681.04.04,0,0,1-.013-.013.042.042,0,0,1-.007-.017.046.046,0,0,1,.007-.035.044.044,0,0,1,.013-.013.045.045,0,0,1,.017-.007.042.042,0,0,1,.018,0,.044.044,0,0,1,.017.007,2.639,2.639,0,0,1,.716.707.044.044,0,0,1,.007.017.048.048,0,0,1-.007.035.048.048,0,0,1-.013.013.046.046,0,0,1-.026.007Z",
  transform: "translate(-1586.177 -1292.984)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1094",
  "data-name": "Path 1094",
  d: "M1816.883,1561.141a.045.045,0,0,1-.02,0,.045.045,0,0,1-.016-.012l-.206-.247a.046.046,0,0,1-.01-.034.047.047,0,0,1,.016-.031.046.046,0,0,1,.034-.01.047.047,0,0,1,.031.016l.205.246a.042.042,0,0,1,.009.016.046.046,0,0,1,0,.035.043.043,0,0,1-.011.014A.048.048,0,0,1,1816.883,1561.141Z",
  transform: "translate(-1594.733 -1314.732)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1095",
  "data-name": "Path 1095",
  d: "M2264.81,1526.357h-.011l-1.068-.249a.048.048,0,0,1-.017-.008.045.045,0,0,1-.013-.013.05.05,0,0,1-.006-.036.048.048,0,0,1,.057-.036l1.068.249a.047.047,0,0,1,.024.083A.047.047,0,0,1,2264.81,1526.357Z",
  transform: "translate(-2031.151 -1280.774)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1096",
  "data-name": "Path 1096",
  d: "M2284.8,1541.607h-.006l-.246-.043a.05.05,0,0,1-.017-.007.052.052,0,0,1-.013-.013.049.049,0,0,1-.008-.035.048.048,0,0,1,.055-.038l.246.043a.046.046,0,0,1,.031.016.048.048,0,0,1,.011.034.046.046,0,0,1-.05.042Z",
  transform: "translate(-2051.472 -1295.862)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1097",
  "data-name": "Path 1097",
  d: "M1927.605,1737.557a2.675,2.675,0,0,1-.786-.117.047.047,0,0,1-.017-.009.047.047,0,0,1-.012-.014.045.045,0,0,1,0-.037.043.043,0,0,1,.01-.016.049.049,0,0,1,.015-.011.045.045,0,0,1,.037,0,2.584,2.584,0,0,0,.932.107.048.048,0,0,1,.034.011.045.045,0,0,1,.016.032.047.047,0,0,1-.043.05C1927.728,1737.555,1927.666,1737.557,1927.605,1737.557Z",
  transform: "translate(-1702.264 -1487.076)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1098",
  "data-name": "Path 1098",
  d: "M1521.818,1396.66h-.006l-.329-.041a.046.046,0,0,1-.031-.018.045.045,0,0,1-.009-.034.046.046,0,0,1,.052-.04l.329.042a.044.044,0,0,1,.017,0,.045.045,0,0,1,.015.011.042.042,0,0,1,.009.016.047.047,0,0,1-.013.05.043.043,0,0,1-.016.009.047.047,0,0,1-.018,0Z",
  transform: "translate(-1306.573 -1154.369)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1099",
  "data-name": "Path 1099",
  d: "M1737.531,419.779l-1.891-.111a.046.046,0,0,1-.028-.081.047.047,0,0,1,.034-.012l1.891.111a.046.046,0,0,1,.018,0,.047.047,0,0,1,.015.01.044.044,0,0,1,.01.015.044.044,0,0,1,0,.018.047.047,0,0,1-.015.032.044.044,0,0,1-.015.01.046.046,0,0,1-.018,0Z",
  transform: "translate(-1515.628 -200.68)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1100",
  "data-name": "Path 1100",
  d: "M1724.571,456.1h0l-2.35-.164a.048.048,0,0,1-.018,0,.046.046,0,0,1-.026-.045.048.048,0,0,1,.016-.032.047.047,0,0,1,.034-.011l2.35.166a.046.046,0,0,1,.032.014.046.046,0,0,1,0,.065.046.046,0,0,1-.033.013Z",
  transform: "translate(-1502.525 -236.089)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1101",
  "data-name": "Path 1101",
  d: "M2312.323,668.5h-.246a.046.046,0,0,1-.046-.046.046.046,0,0,1,.013-.033.046.046,0,0,1,.033-.014h.246a.046.046,0,1,1,0,.093Z",
  transform: "translate(-2078.336 -443.592)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1102",
  "data-name": "Path 1102",
  d: "M2154.036,550.879h-.006l-.781-.084a.047.047,0,0,1-.041-.051.048.048,0,0,1,.017-.031.047.047,0,0,1,.034-.01l.78.084a.047.047,0,0,1,.032.015.053.053,0,0,1,.009.016.05.05,0,0,1,0,.018.044.044,0,0,1,0,.018.042.042,0,0,1-.011.015.046.046,0,0,1-.033.012Z",
  transform: "translate(-1923.294 -328.685)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1103",
  "data-name": "Path 1103",
  d: "M2136.418,578.682h0l-.37-.038a.046.046,0,0,1-.017-.005.043.043,0,0,1-.014-.012.049.049,0,0,1-.009-.016.055.055,0,0,1,0-.018.046.046,0,0,1,.017-.031.045.045,0,0,1,.033-.01l.37.038a.046.046,0,0,1,.032.015.048.048,0,0,1,.012.033.047.047,0,0,1-.049.044Z",
  transform: "translate(-1906.5 -355.872)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1104",
  "data-name": "Path 1104",
  d: "M2146.5,595.994h-.123a.046.046,0,0,1-.033-.014.046.046,0,0,1,0-.065.046.046,0,0,1,.033-.014h.123a.046.046,0,0,1,.033.014.046.046,0,0,1,0,.065A.046.046,0,0,1,2146.5,595.994Z",
  transform: "translate(-1916.581 -372.808)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1105",
  "data-name": "Path 1105",
  d: "M2341.055,1226.956h-.008c-.2-.036-.412-.061-.613-.085s-.412-.049-.618-.086a.048.048,0,0,1-.017-.007.042.042,0,0,1-.013-.013.043.043,0,0,1-.008-.035.048.048,0,0,1,.006-.017.047.047,0,0,1,.013-.013.05.05,0,0,1,.017-.007.053.053,0,0,1,.019,0c.2.036.412.061.613.085s.411.049.617.086a.045.045,0,0,1,.031.016.046.046,0,0,1,.011.034.048.048,0,0,1-.016.032.046.046,0,0,1-.034.011Z",
  transform: "translate(-2105.422 -988.579)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1106",
  "data-name": "Path 1106",
  d: "M2329.4,1202.355a.079.079,0,0,1-.022,0,2.4,2.4,0,0,0-1-.12.07.07,0,0,1-.076-.063.069.069,0,0,1,.063-.076,2.541,2.541,0,0,1,1.056.127.068.068,0,0,1,.037.03.07.07,0,0,1,.009.047.07.07,0,0,1-.069.058Z",
  transform: "translate(-2094.226 -964.555)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1107",
  "data-name": "Path 1107",
  d: "M1861.1,1491.814a.1.1,0,0,1-.028-.2l.727-.2a.1.1,0,0,1,.115.15.1.1,0,0,1-.059.05l-.727.2a.1.1,0,0,1-.028,0Z",
  transform: "translate(-1638.042 -1246.987)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1108",
  "data-name": "Path 1108",
  d: "M1896.75,1506.109a.072.072,0,0,1-.031-.007.069.069,0,0,1-.024-.021l-.12-.163a.07.07,0,0,1-.013-.025.071.071,0,0,1,0-.028.069.069,0,0,1,.009-.026.065.065,0,0,1,.019-.021.067.067,0,0,1,.026-.012.066.066,0,0,1,.028,0,.074.074,0,0,1,.026.01.074.074,0,0,1,.02.02l.12.163a.069.069,0,0,1,.006.072.07.07,0,0,1-.026.028.072.072,0,0,1-.036.011Z",
  transform: "translate(-1672.757 -1261.045)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1109",
  "data-name": "Path 1109",
  d: "M1910.851,1528.419a.07.07,0,0,1-.031-.007.076.076,0,0,1-.025-.02l-.136-.18a.069.069,0,0,1-.014-.051.07.07,0,0,1,.027-.046.069.069,0,0,1,.1.013l.139.179a.072.072,0,0,1,.014.036.073.073,0,0,1-.007.037.066.066,0,0,1-.025.028.069.069,0,0,1-.037.01Z",
  transform: "translate(-1686.508 -1282.811)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1110",
  "data-name": "Path 1110",
  d: "M1926.57,1549.953a.068.068,0,0,1-.031-.007.067.067,0,0,1-.024-.02l-.1-.135a.069.069,0,0,1-.014-.024.074.074,0,0,1,0-.028.07.07,0,0,1,.009-.027.068.068,0,0,1,.018-.021.066.066,0,0,1,.025-.012.071.071,0,0,1,.028,0,.068.068,0,0,1,.026.01.065.065,0,0,1,.02.019l.1.135a.073.073,0,0,1,.014.035.072.072,0,0,1-.007.038.069.069,0,0,1-.026.028.068.068,0,0,1-.037.011Z",
  transform: "translate(-1701.883 -1303.872)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1111",
  "data-name": "Path 1111",
  d: "M1838.888,1506.853a.019.019,0,0,1-.013-.006,3.914,3.914,0,0,0-.673-.634l0,0a.017.017,0,0,1,0-.006.017.017,0,0,1,0-.007.016.016,0,0,1,0-.006.018.018,0,0,1,.024,0,3.938,3.938,0,0,1,.68.64.018.018,0,0,1,.005.012.017.017,0,0,1-.005.012l-.006,0Z",
  transform: "translate(-1615.782 -1261.413)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1112",
  "data-name": "Path 1112",
  d: "M1852.025,1533.929a.021.021,0,0,1-.012,0l-.205-.192-.005-.005a.015.015,0,0,1,0-.007.013.013,0,0,1,0-.008.018.018,0,0,1,0-.007l.006,0h.007l.007,0,.006,0,.206.192a.015.015,0,0,1,0,.006.015.015,0,0,1,0,.007.016.016,0,0,1,0,.007l0,.005-.006,0-.006,0Z",
  transform: "translate(-1629.064 -1288.276)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1113",
  "data-name": "Path 1113",
  d: "M1876.233,1549.058a.015.015,0,0,1-.01,0,.017.017,0,0,1-.006-.01,1.53,1.53,0,0,0-.391-.676.017.017,0,0,1-.005-.012.018.018,0,0,1,.005-.012.016.016,0,0,1,.012,0,.016.016,0,0,1,.012,0,1.556,1.556,0,0,1,.4.691.017.017,0,0,1,0,.013.017.017,0,0,1-.01.008Z",
  transform: "translate(-1652.512 -1302.568)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1114",
  "data-name": "Path 1114",
  d: "M1520.124,1446.678l-.008,0a.016.016,0,0,1-.006-.006l-.231-.358a.022.022,0,0,1,0-.007.012.012,0,0,1,0-.007.017.017,0,0,1,.007-.011.019.019,0,0,1,.013,0,.017.017,0,0,1,.011.008l.231.358a.017.017,0,0,1,0,.013.017.017,0,0,1-.007.011.017.017,0,0,1-.01,0Z",
  transform: "translate(-1305.044 -1202.943)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1115",
  "data-name": "Path 1115",
  d: "M1539.213,1457.089a.015.015,0,0,1-.009,0,.016.016,0,0,1-.007-.007l-.1-.217a.016.016,0,0,1,0-.013.017.017,0,0,1,.009-.01.018.018,0,0,1,.013,0,.019.019,0,0,1,.01.009l.1.216a.017.017,0,0,1,0,.013.017.017,0,0,1-.009.01l-.006,0Z",
  transform: "translate(-1323.803 -1213.244)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1116",
  "data-name": "Path 1116",
  d: "M896.812,1125.086h-.007l-.191-.083-.005,0,0-.005a.019.019,0,0,1,0-.007.018.018,0,0,1,0-.007l0-.005.006,0h.013l.191.083a.019.019,0,0,1,.009.01.015.015,0,0,1-.007.02l-.009,0Z",
  transform: "translate(-696.612 -889.279)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1117",
  "data-name": "Path 1117",
  d: "M1536.531,1434.763a.074.074,0,0,1-.031-.008.076.076,0,0,1-.022-.018.069.069,0,0,1-.013-.026,2.228,2.228,0,0,0-.434-.879.069.069,0,0,1-.016-.037.072.072,0,0,1,.007-.04.073.073,0,0,1,.029-.029.069.069,0,0,1,.039-.008,4.449,4.449,0,0,1,1.629.462.069.069,0,0,1,.037.065.068.068,0,0,1-.013.037.072.072,0,0,1-.031.024l-1.156.45A.075.075,0,0,1,1536.531,1434.763Zm-.293-.885a2.384,2.384,0,0,1,.339.726l.937-.366a4.3,4.3,0,0,0-1.276-.36Z",
  transform: "translate(-1320.797 -1190.676)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1118",
  "data-name": "Path 1118",
  d: "M908.9,1653.24a6.774,6.774,0,0,1,1.781,1.732,27.276,27.276,0,0,0,2.286,2.633l.269-1.2S910.365,1653.234,908.9,1653.24Z",
  transform: "translate(-708.615 -1404.97)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1119",
  "data-name": "Path 1119",
  d: "M974.937,1694.584l-.007,0-.006,0-.679-.719,0-.006a.018.018,0,0,1,0-.007.019.019,0,0,1,0-.007l0-.005a.017.017,0,0,1,.025,0l.68.719a.018.018,0,0,1,0,.025l-.005,0Z",
  transform: "translate(-772.4 -1444.594)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1120",
  "data-name": "Path 1120",
  d: "M1010.5,1740.109l-.008,0-.006-.005-.283-.377a.018.018,0,0,1,0-.012.017.017,0,0,1,.007-.01.016.016,0,0,1,.011,0,.017.017,0,0,1,.011,0l.282.377,0,.006a.017.017,0,0,1,0,.007.015.015,0,0,1,0,.006l0,.005A.02.02,0,0,1,1010.5,1740.109Z",
  transform: "translate(-807.503 -1489.37)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1121",
  "data-name": "Path 1121",
  d: "M1037.127,1751.19a.017.017,0,0,1-.01,0,3.909,3.909,0,0,1-.927-.867.016.016,0,0,1,0-.006.017.017,0,0,1,0-.007.02.02,0,0,1,0-.006l0-.005a.017.017,0,0,1,.013,0,.016.016,0,0,1,.012.006,3.9,3.9,0,0,0,.92.86.018.018,0,0,1,.007.011.018.018,0,0,1,0,.013l-.006.006-.008,0Z",
  transform: "translate(-832.871 -1499.712)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1122",
  "data-name": "Path 1122",
  d: "M1053.3,1789.7h-.007l-.006,0-.5-.541a.018.018,0,0,1,0-.023.018.018,0,0,1,.011,0,.017.017,0,0,1,.012,0l.5.543a.019.019,0,0,1,.005.012.017.017,0,0,1-.005.012.018.018,0,0,1-.014,0Z",
  transform: "translate(-849.075 -1537.623)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1123",
  "data-name": "Path 1123",
  d: "M1312.218,1982.943h-.432a.046.046,0,1,1,0-.093h.432a.046.046,0,1,1,0,.093Z",
  transform: "translate(-1101.864 -1726.732)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1124",
  "data-name": "Path 1124",
  d: "M1343.535,2014.013h-.678a.046.046,0,0,1,0-.093h.678a.046.046,0,0,1,0,.093Z",
  transform: "translate(-1132.194 -1757.062)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  "data-name": "Path 1125",
  d: "M1361.346,2029.552h-.37a.046.046,0,0,1-.033-.014.046.046,0,0,1-.014-.033.047.047,0,0,1,.014-.033.046.046,0,0,1,.033-.014h.37a.046.046,0,0,1,.046.046.045.045,0,0,1-.014.033A.046.046,0,0,1,1361.346,2029.552Z",
  transform: "translate(-1149.882 -1772.232)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  "data-name": "Path 1126",
  d: "M2241.48,464.832l3.872.3a3.883,3.883,0,0,0-2.455-3.623,4.163,4.163,0,0,0-1.347-.316l-.069,3.583.069-3.583Z",
  transform: "translate(-2009.466 -241.307)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  "data-name": "Path 1127",
  d: "M2242.5,462.433h-.005l-3.872-.3a.069.069,0,0,1-.063-.074.057.057,0,0,1,.006-.023.061.061,0,0,1-.006-.029l.069-3.583a.071.071,0,0,1,.017-.046h0l0-.005,0,0a.07.07,0,0,1,.043-.016h.005a4.21,4.21,0,0,1,1.369.321,3.96,3.96,0,0,1,2.5,3.689.073.073,0,0,1-.023.049A.07.07,0,0,1,2242.5,462.433Zm-3.8-.433,3.734.289a3.829,3.829,0,0,0-2.414-3.484,4.071,4.071,0,0,0-1.252-.306Z",
  transform: "translate(-2006.617 -238.539)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  "data-name": "Path 1128",
  d: "M1074.509,2388.5a.07.07,0,0,1-.024,0,25.523,25.523,0,0,0-9.629-1.2.073.073,0,0,1-.027,0,.067.067,0,0,1-.024-.013.067.067,0,0,1-.017-.021.068.068,0,0,1-.008-.026.078.078,0,0,1,0-.027.081.081,0,0,1,.013-.024.071.071,0,0,1,.047-.025,25.708,25.708,0,0,1,9.689,1.209.07.07,0,0,1,.021.118.069.069,0,0,1-.044.017Z",
  transform: "translate(-860.784 -2121.356)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  "data-name": "Path 1129",
  d: "M1316.618,2291.754a.069.069,0,0,1-.047-.019.068.068,0,0,1-.022-.046,4.687,4.687,0,0,1,.277-1.917.069.069,0,0,1,.086-.035.067.067,0,0,1,.038.032.069.069,0,0,1,.007.049,4.547,4.547,0,0,0-.271,1.86.071.071,0,0,1,0,.027.07.07,0,0,1-.014.024.069.069,0,0,1-.021.017.066.066,0,0,1-.026.007Z",
  transform: "translate(-1106.549 -2026.307)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1130",
  "data-name": "Path 1130",
  d: "M1291.76,2332.894a.073.073,0,0,1-.038-.011.072.072,0,0,1-.026-.03,1.354,1.354,0,0,1-.087-.809.071.071,0,0,1,.01-.025.067.067,0,0,1,.019-.019.069.069,0,0,1,.077,0,.072.072,0,0,1,.019.019.074.074,0,0,1,.01.025.068.068,0,0,1,0,.027,1.217,1.217,0,0,0,.078.726.065.065,0,0,1,.006.033.067.067,0,0,1-.011.032.068.068,0,0,1-.025.023.071.071,0,0,1-.033.009Z",
  transform: "translate(-1082.186 -2067.556)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1131",
  "data-name": "Path 1131",
  d: "M1237.817,2551.39a.043.043,0,0,1-.021-.005l-1.691-.838a.046.046,0,0,1-.023-.027.046.046,0,0,1,0-.035.046.046,0,0,1,.027-.023.047.047,0,0,1,.035,0l1.691.838a.046.046,0,0,1,.025.052.045.045,0,0,1-.016.026.048.048,0,0,1-.029.01Z",
  transform: "translate(-1028.005 -2280.826)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1132",
  "data-name": "Path 1132",
  d: "M1287.117,2559.864a.046.046,0,0,1-.028-.009.834.834,0,0,0-.364-.156.05.05,0,0,1-.017-.007.046.046,0,0,1-.013-.012.047.047,0,0,1-.008-.017.049.049,0,0,1,0-.018.041.041,0,0,1,.006-.017.042.042,0,0,1,.012-.013.051.051,0,0,1,.017-.008.046.046,0,0,1,.018,0,.936.936,0,0,1,.4.173.053.053,0,0,1,.012.014.042.042,0,0,1,.006.017.041.041,0,0,1,0,.018.044.044,0,0,1-.008.016.05.05,0,0,1-.016.014A.045.045,0,0,1,1287.117,2559.864Z",
  transform: "translate(-1077.406 -2289.755)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1133",
  "data-name": "Path 1133",
  d: "M551.495,2621.6a4.773,4.773,0,0,1,3.838-2.475,4.377,4.377,0,0,1,3.97,2.666h-.575a3.768,3.768,0,0,0-3.329-2.216,3.861,3.861,0,0,0-3.26,2Z",
  transform: "translate(-359.721 -2347.861)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1134",
  "data-name": "Path 1134",
  d: "M556.453,2619.015h-.576a.067.067,0,0,1-.038-.011.069.069,0,0,1-.025-.031,3.726,3.726,0,0,0-3.259-2.173h-.006a3.814,3.814,0,0,0-3.2,1.966.07.07,0,0,1-.025.027.071.071,0,0,1-.035.011l-.644.022a.069.069,0,0,1-.035-.008.072.072,0,0,1-.026-.024.067.067,0,0,1-.011-.034.069.069,0,0,1,.008-.035,5.5,5.5,0,0,1,.983-1.255,4.175,4.175,0,0,1,6.055.1,4.63,4.63,0,0,1,.9,1.355.071.071,0,0,1,0,.032.069.069,0,0,1-.036.052.071.071,0,0,1-.031.008Zm-.531-.139h.425a4.751,4.751,0,0,0-.832-1.22,4.069,4.069,0,0,0-3.033-1.307,4.647,4.647,0,0,0-3.716,2.332l.479-.016a3.942,3.942,0,0,1,3.3-2h.008a3.557,3.557,0,0,1,2.608,1.128,4.207,4.207,0,0,1,.758,1.088Z",
  transform: "translate(-356.87 -2345.011)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1135",
  "data-name": "Path 1135",
  d: "M510.209,2699.554a1.007,1.007,0,1,0-1.007-1.007A1.007,1.007,0,0,0,510.209,2699.554Z",
  transform: "translate(-318.435 -2424.405)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1136",
  "data-name": "Path 1136",
  d: "M507.345,2696.766a1.078,1.078,0,1,1,.76-.316,1.08,1.08,0,0,1-.76.316Zm0-2.014a.939.939,0,1,0,.662.275.936.936,0,0,0-.662-.275Z",
  transform: "translate(-315.571 -2421.547)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1137",
  "data-name": "Path 1137",
  d: "M842.31,2699.554a1.007,1.007,0,1,0-1.007-1.007A1.007,1.007,0,0,0,842.31,2699.554Z",
  transform: "translate(-642.628 -2424.405)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1138",
  "data-name": "Path 1138",
  d: "M839.447,2696.766a1.078,1.078,0,1,1,.76-.316A1.08,1.08,0,0,1,839.447,2696.766Zm0-2.014a.939.939,0,1,0,.662.275.936.936,0,0,0-.662-.275Z",
  transform: "translate(-639.765 -2421.547)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1139",
  "data-name": "Path 1139",
  d: "M613.584,1948.794a.112.112,0,0,1-.042-.009c-.06-.026-5.994-2.594-8.019-3.2a.1.1,0,0,1-.069-.133.106.106,0,0,1,.031-.046l1.96-1.7a23.29,23.29,0,0,1-5.4-1.442,10.765,10.765,0,0,1-3.787-2.462,5.387,5.387,0,0,1-1.515-4.192.106.106,0,0,1,.017-.05.1.1,0,0,1,.039-.035,31.867,31.867,0,0,1,10.98-2.949,28.927,28.927,0,0,1,10.823,1.056,29.523,29.523,0,0,1,11.8,6.955.1.1,0,0,1,.025.036.1.1,0,0,1,0,.086.1.1,0,0,1-.028.034l-7.712,6.175a.106.106,0,0,1-.054.022.1.1,0,0,1-.057-.01c-.039-.019-3.845-1.9-4.935-2.2-.314.334-2.309,2.451-3.976,4.028A.1.1,0,0,1,613.584,1948.794Zm-7.821-3.354c2.059.657,7.171,2.856,7.8,3.127,1.79-1.7,3.937-3.994,3.959-4.017a.1.1,0,0,1,.046-.029.1.1,0,0,1,.054,0,48.007,48.007,0,0,1,4.976,2.2l7.568-6.057a28.4,28.4,0,0,0-22.373-7.874,31.875,31.875,0,0,0-10.85,2.9c-.172,2.734,1.569,4.883,5.175,6.387a23.026,23.026,0,0,0,5.582,1.459.1.1,0,0,1,.055.023.1.1,0,0,1,.034.109.1.1,0,0,1-.032.05Z",
  transform: "translate(-403.872 -1677.544)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1140",
  "data-name": "Path 1140",
  d: "M296.62,1187.543a.1.1,0,0,1-.041-.008.1.1,0,0,1-.034-.024l-7.338-7.583a.1.1,0,0,1-.026-.045.1.1,0,0,1,0-.052,23.3,23.3,0,0,1,6.937-12.075,7.035,7.035,0,0,1,4.192-1.7,7.61,7.61,0,0,1,2.121.127,12.857,12.857,0,0,1,7.5,3.341,12,12,0,0,1,2.246,2.749,37.219,37.219,0,0,1,4.522-1.1.1.1,0,0,1,.069.012,4.464,4.464,0,0,1,1.988,2.312l3.165-1.192a.105.105,0,0,1,.068,0,11.588,11.588,0,0,1,4.627,2.985,13.48,13.48,0,0,1,1.67,2.055.1.1,0,0,1,.013.075.1.1,0,0,1-.041.064c-.068.046-6.862,4.851-11.267,6.034a8.809,8.809,0,0,1-6.084-.865,13.9,13.9,0,0,1-2.561-1.646,8.565,8.565,0,0,1-1.6,3.657.1.1,0,0,1-.07.037,33.765,33.765,0,0,0-10.01,2.837.108.108,0,0,1-.046.011Zm-7.226-7.719,7.247,7.491a34,34,0,0,1,9.969-2.821,8.339,8.339,0,0,0,1.555-3.706.1.1,0,0,1,.022-.051.1.1,0,0,1,.1-.037.1.1,0,0,1,.049.025,13.268,13.268,0,0,0,2.664,1.739,8.6,8.6,0,0,0,5.933.848c4.109-1.1,10.334-5.4,11.119-5.945a12.831,12.831,0,0,0-6.1-4.859l-3.234,1.217a.1.1,0,0,1-.042.006.1.1,0,0,1-.075-.038.1.1,0,0,1-.02-.038,4.254,4.254,0,0,0-1.892-2.277,36.075,36.075,0,0,0-4.536,1.117.1.1,0,0,1-.127-.05,11.416,11.416,0,0,0-2.252-2.775,12.664,12.664,0,0,0-7.38-3.283h-.014a7.467,7.467,0,0,0-2.071-.123,6.83,6.83,0,0,0-4.062,1.65A23.071,23.071,0,0,0,289.395,1179.824Z",
  transform: "translate(-103.65 -929.364)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1141",
  "data-name": "Path 1141",
  d: "M708.67,1902.557a.8.8,0,0,0,.312-1.006,24.574,24.574,0,0,0-8.369,1.983l.22.827A40.942,40.942,0,0,1,708.67,1902.557Z",
  transform: "translate(-505.288 -1647.368)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1142",
  "data-name": "Path 1142",
  d: "M698.005,1901.637a.07.07,0,0,1-.055-.027.068.068,0,0,1-.012-.025l-.219-.827a.07.07,0,0,1,.039-.082,24.831,24.831,0,0,1,8.4-1.988.071.071,0,0,1,.041.012.068.068,0,0,1,.026.034.876.876,0,0,1-.347,1.089.067.067,0,0,1-.028.008,41.153,41.153,0,0,0-7.819,1.8A.061.061,0,0,1,698.005,1901.637Zm-.139-.857.185.7a40.473,40.473,0,0,1,7.768-1.784.725.725,0,0,0,.281-.867,24.837,24.837,0,0,0-8.231,1.952Z",
  transform: "translate(-502.461 -1644.574)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1143",
  "data-name": "Path 1143",
  d: "M189.557,1653.633c1.579-.592,5.549-.945,7.48,2.219s2.754,11.878,5.261,13.235a18.327,18.327,0,0,0,5.919,1.694s.263.565-.857.633c-9.978.605-16.61,1.8-18.911-2.011C186.03,1665.4,183.967,1655.729,189.557,1653.633Z",
  transform: "translate(-2.918 -1404.969)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1144",
  "data-name": "Path 1144",
  d: "M193.058,1669.347c-3.735,0-6.308-.591-7.588-2.712a19.078,19.078,0,0,1-2.137-5.909,13.444,13.444,0,0,1,.171-6.628,5.156,5.156,0,0,1,3.111-3.333,7.642,7.642,0,0,1,3.643-.3,5.489,5.489,0,0,1,3.921,2.551,25.726,25.726,0,0,1,2.04,5.907c.862,3.207,1.754,6.523,3.194,7.3a18.417,18.417,0,0,0,5.893,1.686.07.07,0,0,1,.033.012.068.068,0,0,1,.023.027.428.428,0,0,1-.025.379c-.122.2-.422.323-.891.352-1.512.093-2.931.2-4.3.3C197.453,1669.173,195.085,1669.347,193.058,1669.347Zm-6.419-18.518.024.065a5.023,5.023,0,0,0-3.029,3.248c-1.382,3.977.349,9.761,1.954,12.421,1.93,3.2,6.948,2.832,14.544,2.274,1.372-.1,2.791-.2,4.3-.3.524-.032.713-.173.781-.285a.286.286,0,0,0,.036-.1.282.282,0,0,0-.007-.11,18.442,18.442,0,0,1-5.9-1.7c-1.492-.807-2.392-4.153-3.262-7.388a25.685,25.685,0,0,0-2.025-5.872c-2.013-3.3-6.117-2.67-7.4-2.19Z",
  transform: "translate(0 -1402.166)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1145",
  "data-name": "Path 1145",
  d: "M478.812,2326.984a.1.1,0,0,1,.026.139c-.023.03-.122.02-.142-.006a.115.115,0,0,1-.023-.04.111.111,0,0,1,0-.046.108.108,0,0,1,.014-.043.113.113,0,0,1,.031-.034C478.766,2326.9,478.782,2326.959,478.812,2326.984Z",
  transform: "translate(-288.628 -2062.622)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1146",
  "data-name": "Path 1146",
  d: "M237.637,2045.162c-.019-.019-.043-.039-.02-.07a.111.111,0,0,1,.133,0c.031.028.009.046-.012.069S237.673,2045.22,237.637,2045.162Z",
  transform: "translate(-53.307 -1787.47)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1147",
  "data-name": "Path 1147",
  d: "M454.376,2374.276c-.031.03-.052.011-.07-.012s-.061-.046-.019-.085a.076.076,0,0,1,.047-.02.078.078,0,0,1,.049.012.081.081,0,0,1-.007.1Z",
  transform: "translate(-264.81 -2108.723)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1148",
  "data-name": "Path 1148",
  d: "M646.769,2177.211c-.02-.023-.041-.046-.01-.071a.082.082,0,0,1,.108,0,.084.084,0,0,1-.016.1C646.807,2177.272,646.79,2177.231,646.769,2177.211Z",
  transform: "translate(-452.701 -1916.376)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1149",
  "data-name": "Path 1149",
  d: "M740.693,2172.1a.262.262,0,0,1,.02-.1c.028-.043.057-.015.081.013s.042.039.018.07a.16.16,0,0,1-.119.013Z",
  transform: "translate(-544.414 -1911.363)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1150",
  "data-name": "Path 1150",
  d: "M296.963,2310.291c-.026-.023-.046-.056,0-.079a.193.193,0,0,1,.1-.007c.012,0-.01.1-.027.114S297,2310.327,296.963,2310.291Z",
  transform: "translate(-111.222 -2046.289)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1151",
  "data-name": "Path 1151",
  d: "M407.771,2239.977c-.028,0-.071.007-.081-.007a.087.087,0,0,1,.009-.107.041.041,0,0,1,.011-.01.038.038,0,0,1,.015,0,.035.035,0,0,1,.015,0,.034.034,0,0,1,.013.009C407.794,2239.892,407.765,2239.936,407.771,2239.977Z",
  transform: "translate(-219.326 -1977.611)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1152",
  "data-name": "Path 1152",
  d: "M496.635,2345.881a.3.3,0,0,1-.035-.057c0-.009.009-.024.016-.035a.036.036,0,0,1,.011-.011.029.029,0,0,1,.015,0,.032.032,0,0,1,.015,0,.033.033,0,0,1,.013.009c.039.033.015.077.016.117Z",
  transform: "translate(-306.133 -2081.014)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1153",
  "data-name": "Path 1153",
  d: "M567.824,2163.112a.024.024,0,0,1-.008-.012.027.027,0,0,1,0-.014.029.029,0,0,1,.007-.013.029.029,0,0,1,.012-.007c.025-.013.039-.069.076-.031a.078.078,0,0,1,0,.078C567.892,2163.126,567.853,2163.113,567.824,2163.112Z",
  transform: "translate(-375.652 -1902.613)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1154",
  "data-name": "Path 1154",
  d: "M452.278,2281.01a.04.04,0,0,1,.008-.056c.03-.027.051-.013.069.011a.037.037,0,0,1,.007.014.035.035,0,0,1,0,.015.036.036,0,0,1-.005.015.035.035,0,0,1-.011.011C452.317,2281.047,452.3,2281.031,452.278,2281.01Z",
  transform: "translate(-262.859 -2017.724)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1155",
  "data-name": "Path 1155",
  d: "M731.8,2253.666c-.016-.015-.025-.032,0-.046.006,0,.024.008.034.016s.025.032,0,.046C731.831,2253.685,731.814,2253.671,731.8,2253.666Z",
  transform: "translate(-535.719 -1991.053)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1156",
  "data-name": "Path 1156",
  d: "M778.151,2378.512c-.006-.028.018-.037.033-.05s.027,0,.03.01c.008.026-.017.036-.032.046S778.162,2378.515,778.151,2378.512Z",
  transform: "translate(-580.979 -2112.923)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1157",
  "data-name": "Path 1157",
  d: "M727.814,1984.431c.015-.016.032-.025.046,0,0,.006-.008.024-.016.034s-.031.025-.046,0C727.8,1984.46,727.809,1984.443,727.814,1984.431Z",
  transform: "translate(-531.826 -1728.26)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1158",
  "data-name": "Path 1158",
  d: "M696.426,2068.872l-.007-.031h.02a.139.139,0,0,1,.01.031Z",
  transform: "translate(-501.194 -1810.674)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1159",
  "data-name": "Path 1159",
  d: "M701.2,2186.972v-.022a.135.135,0,0,1,.03.013s0,.013,0,.02Z",
  transform: "translate(-505.857 -1925.972)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1160",
  "data-name": "Path 1160",
  d: "M741.682,2047.727a.093.093,0,0,1,0-.019.056.056,0,0,1,.032,0c.019.008.019.021,0,.027A.1.1,0,0,1,741.682,2047.727Z",
  transform: "translate(-545.378 -1790.041)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1161",
  "data-name": "Path 1161",
  d: "M743.679,2047.79c.011,0,.028,0,.031.006s0,.028-.013.024a.18.18,0,0,1-.032-.017Z",
  transform: "translate(-547.314 -1790.126)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1162",
  "data-name": "Path 1162",
  d: "M433.246,1949.3c.038.038.054.072-.008.114s-.071-.008-.1-.037-.056-.074.005-.117S433.218,1949.265,433.246,1949.3Z",
  transform: "translate(-244.151 -1693.923)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1163",
  "data-name": "Path 1163",
  d: "M532.049,1862.837c-.021-.042.007-.053.028-.071a.087.087,0,0,1,.028-.019.086.086,0,0,1,.094.019.08.08,0,0,1,0,.05.082.082,0,0,1-.028.042.115.115,0,0,1-.065.008.118.118,0,0,1-.059-.029Z",
  transform: "translate(-340.731 -1609.482)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1164",
  "data-name": "Path 1164",
  d: "M476.114,1985.145c-.026-.033-.006-.052.018-.068s.05-.056.086-.012a.066.066,0,0,1,.021.051.066.066,0,0,1-.008.028.063.063,0,0,1-.018.021.064.064,0,0,1-.026.012.065.065,0,0,1-.028,0,.067.067,0,0,1-.026-.012.061.061,0,0,1-.019-.021Z",
  transform: "translate(-286.122 -1728.874)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1165",
  "data-name": "Path 1165",
  d: "M571.992,1733.85a.262.262,0,0,1,.093.028c.039.031.01.057-.021.079s-.042.038-.071.012a.158.158,0,0,1,0-.119Z",
  transform: "translate(-379.719 -1483.661)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1166",
  "data-name": "Path 1166",
  d: "M296.7,2022.873c0-.038.027-.049.046-.066s.046-.029.069,0a.039.039,0,0,1,.011.018.037.037,0,0,1,0,.021.037.037,0,0,1-.011.017.036.036,0,0,1-.019.009.332.332,0,0,1-.1,0Z",
  transform: "translate(-110.988 -1765.721)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1167",
  "data-name": "Path 1167",
  d: "M281.278,1851.606a.029.029,0,0,1-.007-.013.027.027,0,0,1,0-.015.027.027,0,0,1,.021-.019c.026-.011.046-.065.078-.024a.079.079,0,0,1-.012.077C281.342,1851.626,281.305,1851.61,281.278,1851.606Z",
  transform: "translate(-95.93 -1598.53)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1168",
  "data-name": "Path 1168",
  d: "M497.55,1912.693c.013-.037-.007-.086.039-.11a.091.091,0,0,1,.039,0c-.012.037.006.085-.039.11a.1.1,0,0,1-.039,0Z",
  transform: "translate(-307.06 -1658.135)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1169",
  "data-name": "Path 1169",
  d: "M425.67,1871.252a.037.037,0,0,1,.014-.005.035.035,0,0,1,.015,0,.037.037,0,0,1,.014.006.04.04,0,0,1,.01.011c.024.032.009.052-.017.067a.037.037,0,0,1-.014.006.034.034,0,0,1-.029-.007.036.036,0,0,1-.01-.012C425.63,1871.289,425.648,1871.271,425.67,1871.252Z",
  transform: "translate(-236.865 -1617.785)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1170",
  "data-name": "Path 1170",
  d: "M314.163,2123.56c.026,0,.067,0,.076.016a.081.081,0,0,1,.005.04.083.083,0,0,1-.015.038c-.042.025-.046-.029-.069-.047S314.14,2123.575,314.163,2123.56Z",
  transform: "translate(-128.022 -1864.091)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1171",
  "data-name": "Path 1171",
  d: "M346.135,2004.705c.023-.016.046-.033.068,0a.157.157,0,0,1,.012.036h-.092Z",
  transform: "translate(-159.238 -1748.048)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1172",
  "data-name": "Path 1172",
  d: "M393.8,2145.914c.016-.014.034-.022.046,0,0,.007-.01.023-.018.032s-.033.022-.046,0C393.778,2145.94,393.793,2145.925,393.8,2145.914Z",
  transform: "translate(-205.762 -1885.9)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1173",
  "data-name": "Path 1173",
  d: "M533.889,2102.846c.029,0,.036.021.046.037a.033.033,0,0,1,0,.016.035.035,0,0,1-.009.013c-.027.006-.034-.02-.046-.036S533.886,2102.855,533.889,2102.846Z",
  transform: "translate(-342.522 -1843.87)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1174",
  "data-name": "Path 1174",
  d: "M265.236,1896.73h.036a.235.235,0,0,1-.031.046c-.007.007-.025,0-.038,0a.051.051,0,0,1,.009-.03.052.052,0,0,1,.025-.02Z",
  transform: "translate(-80.246 -1642.662)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1175",
  "data-name": "Path 1175",
  d: "M204.931,1813.385c.029,0,.036.021.046.037s-.006.026-.012.028c-.026.006-.034-.019-.046-.036S204.927,1813.4,204.931,1813.385Z",
  transform: "translate(-21.397 -1561.302)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1176",
  "data-name": "Path 1176",
  d: "M472.735,1973.822c.029,0,.036.021.046.037s-.006.027-.012.028c-.026.006-.034-.02-.046-.036S472.73,1973.831,472.735,1973.822Z",
  transform: "translate(-282.824 -1717.918)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1177",
  "data-name": "Path 1177",
  d: "M324.589,1880.5l0,.031c-.006,0-.018,0-.019,0a.136.136,0,0,1-.007-.031Z",
  transform: "translate(-138.196 -1626.819)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1178",
  "data-name": "Path 1178",
  d: "M222.56,2147.312l0-.022a.154.154,0,0,1,.028.015s0,.012,0,.019Z",
  transform: "translate(-38.618 -1887.256)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1179",
  "data-name": "Path 1179",
  d: "M337.1,2024.02l.022,0a.121.121,0,0,1-.015.029s-.012,0-.019,0Z",
  transform: "translate(-150.423 -1766.922)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1180",
  "data-name": "Path 1180",
  d: "M536.2,2249.408c.007.006,0,.036,0,.066,0,.01-.006.024-.013.027-.025.011-.167-.062-.164-.087s0-.062.026-.085.046,0,.071,0S536.157,2249.369,536.2,2249.408Z",
  transform: "translate(-344.612 -1986.856)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1181",
  "data-name": "Path 1181",
  d: "M333.3,2186.651a.082.082,0,0,1-.022-.027.08.08,0,0,1-.009-.033.082.082,0,0,1,0-.034.085.085,0,0,1,.018-.029c.023-.023.106,0,.121.021a.1.1,0,0,1,.016.037.1.1,0,0,1,0,.04.1.1,0,0,1-.017.036.093.093,0,0,1-.03.026C333.334,2186.725,333.325,2186.675,333.3,2186.651Z",
  transform: "translate(-146.694 -1925.55)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1182",
  "data-name": "Path 1182",
  d: "M633.74,1955.463c.01.028.062.049.015.089a.109.109,0,0,1-.131.008c-.025-.028-.009-.086.032-.124S633.719,1955.43,633.74,1955.463Z",
  transform: "translate(-439.882 -1699.954)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1183",
  "data-name": "Path 1183",
  d: "M524.033,1852.58c-.034.032-.064.046-.1-.01s.01-.061.035-.083.066-.046.1.008S524.062,1852.557,524.033,1852.58Z",
  transform: "translate(-332.803 -1599.444)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1184",
  "data-name": "Path 1184",
  d: "M881.73,2399.458c.013.02.037.04.021.063s-.053.017-.083.014a.071.071,0,0,1-.04-.02.074.074,0,0,1-.021-.039.236.236,0,0,1,.006-.087.467.467,0,0,1,.085.025C881.713,2399.422,881.72,2399.443,881.73,2399.458Z",
  transform: "translate(-681.971 -2133.354)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1185",
  "data-name": "Path 1185",
  d: "M728.636,2158.129c-.029.026-.049.033-.078,0s-.019-.079-.014-.119c.041.006.083,0,.108.051S728.67,2158.117,728.636,2158.129Z",
  transform: "translate(-532.546 -1897.721)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1186",
  "data-name": "Path 1186",
  d: "M631.6,2395.435a.029.029,0,0,1-.046,0,.13.13,0,0,1-.014-.046c.05-.012.02-.082.068-.1.017-.005.034-.022.046-.019s.007.028,0,.042C631.651,2395.359,631.66,2395.414,631.6,2395.435Z",
  transform: "translate(-437.86 -2129.334)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1187",
  "data-name": "Path 1187",
  d: "M598.236,2207.691a.076.076,0,0,1,.056-.006.075.075,0,0,1,.045.035.108.108,0,0,1-.008.085c-.01.02-.1-.029-.114-.066C598.207,2207.722,598.207,2207.7,598.236,2207.691Z",
  transform: "translate(-405.324 -1946.211)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1188",
  "data-name": "Path 1188",
  d: "M598.414,1941.167c.037-.016.046.008.061.026a.074.074,0,0,1,.021.054.075.075,0,0,1-.007.029.073.073,0,0,1-.017.024.071.071,0,0,1-.043,0,.07.07,0,0,1-.035-.025.1.1,0,0,1,.021-.108Z",
  transform: "translate(-405.496 -1686.036)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1189",
  "data-name": "Path 1189",
  d: "M330.517,2277.471c.015.018.033.038.01.061a.1.1,0,0,1-.059.013.1.1,0,0,1-.055-.025c-.024-.028,0-.042.017-.058S330.493,2277.418,330.517,2277.471Z",
  transform: "translate(-143.893 -2014.305)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1190",
  "data-name": "Path 1190",
  d: "M493.489,1888.783c.03-.022.046,0,.059.017s.046.047.007.075a.057.057,0,0,1-.045.015.061.061,0,0,1-.023-.007.06.06,0,0,1-.018-.016.056.056,0,0,1-.01-.022.057.057,0,0,1,0-.024.059.059,0,0,1,.01-.022.057.057,0,0,1,.018-.016Z",
  transform: "translate(-303.066 -1634.895)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1191",
  "data-name": "Path 1191",
  d: "M633.94,1988.159c-.023.007-.039.008-.049-.013s-.015-.073.015-.089.031.03.046.046S633.954,1988.145,633.94,1988.159Z",
  transform: "translate(-440.145 -1731.812)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1192",
  "data-name": "Path 1192",
  d: "M556.491,1909.61c.031.012.075,0,.093.037a.082.082,0,0,1,0,.034c-.032-.011-.074,0-.093-.037a.084.084,0,0,1,0-.034Z",
  transform: "translate(-364.596 -1655.236)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1193",
  "data-name": "Path 1193",
  d: "M595.5,1848.388a.034.034,0,0,1,0,.026.035.035,0,0,1-.016.021c-.029.02-.046.006-.058-.017a.032.032,0,0,1-.005-.013.032.032,0,0,1,0-.014.032.032,0,0,1,.006-.012.026.026,0,0,1,.011-.008C595.472,1848.352,595.489,1848.368,595.5,1848.388Z",
  transform: "translate(-402.606 -1595.446)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1194",
  "data-name": "Path 1194",
  d: "M379.2,1743.71c0,.022,0,.058-.016.066a.073.073,0,0,1-.035,0,.07.07,0,0,1-.032-.014c-.021-.037.026-.04.043-.059S379.185,1743.69,379.2,1743.71Z",
  transform: "translate(-191.439 -1493.27)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1195",
  "data-name": "Path 1195",
  d: "M506.223,2124.237c.014.02.024.04-.005.06a.033.033,0,0,1-.011.007h-.013a.028.028,0,0,1-.012,0,.027.027,0,0,1-.01-.008c-.017-.02-.024-.04,0-.06a.033.033,0,0,1,.025-.008A.034.034,0,0,1,506.223,2124.237Z",
  transform: "translate(-315.462 -1864.741)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1196",
  "data-name": "Path 1196",
  d: "M626.713,2306.034a.036.036,0,0,1,0,.026.034.034,0,0,1-.015.02c-.029.02-.046.006-.058-.017a.03.03,0,0,1,0-.012.032.032,0,0,1,0-.014.031.031,0,0,1,.006-.012l.01-.008C626.684,2306,626.7,2306.014,626.713,2306.034Z",
  transform: "translate(-433.074 -2042.196)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1197",
  "data-name": "Path 1197",
  d: "M830.855,2388.387c-.02.017-.042.024-.046,0s.031-.033.046-.05.035-.019.039,0S830.861,2388.372,830.855,2388.387Z",
  transform: "translate(-632.383 -2122.555)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1198",
  "data-name": "Path 1198",
  d: "M483.255,1775.1c.013.02.027.041,0,.059a.149.149,0,0,1-.032.009l0-.08Z",
  transform: "translate(-293.07 -1523.919)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1199",
  "data-name": "Path 1199",
  d: "M457.842,2119.078c-.014.012-.03.018-.039,0s.009-.02.017-.027.03-.019.039,0S457.849,2119.069,457.842,2119.078Z",
  transform: "translate(-268.259 -1859.68)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1200",
  "data-name": "Path 1200",
  d: "M714.312,2314.628c-.014.012-.03.018-.04,0s.009-.02.017-.028.03-.018.039,0S714.318,2314.617,714.312,2314.628Z",
  transform: "translate(-518.621 -2050.573)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1201",
  "data-name": "Path 1201",
  d: "M796.618,2207.3l.006.046c-.011,0-.026-.005-.031-.013a.182.182,0,0,1-.013-.049Z",
  transform: "translate(-598.971 -1945.818)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1202",
  "data-name": "Path 1202",
  d: "M641.919,1990.12a.217.217,0,0,1,.042.034c.006.007,0,.022,0,.033a.21.21,0,0,1-.041-.028C641.914,1990.153,641.919,1990.137,641.919,1990.12Z",
  transform: "translate(-447.99 -1733.829)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1203",
  "data-name": "Path 1203",
  d: "M414.1,1806.351v.031a.173.173,0,0,1-.042-.028c-.006-.006,0-.022,0-.033a.042.042,0,0,1,.025.009.045.045,0,0,1,.016.022Z",
  transform: "translate(-225.552 -1554.405)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1204",
  "data-name": "Path 1204",
  d: "M505.86,1886.291c0,.025-.019.03-.034.039s-.023-.005-.024-.011c0-.024.018-.029.032-.038S505.851,1886.288,505.86,1886.291Z",
  transform: "translate(-315.115 -1632.462)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1205",
  "data-name": "Path 1205",
  d: "M743.509,2126.4l0,.028c-.006,0-.015,0-.017,0a.184.184,0,0,1-.005-.028Z",
  transform: "translate(-547.144 -1866.864)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1206",
  "data-name": "Path 1206",
  d: "M747.778,1974.752l0,.019a.111.111,0,0,1-.024-.014s0-.011,0-.017Z",
  transform: "translate(-551.302 -1718.815)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1207",
  "data-name": "Path 1207",
  d: "M701.855,2139.876c0,.006,0,.016,0,.016a.049.049,0,0,1-.028,0c-.016-.009-.014-.02,0-.022A.071.071,0,0,1,701.855,2139.876Z",
  transform: "translate(-506.46 -1880.013)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1208",
  "data-name": "Path 1208",
  d: "M700.137,2139.444c-.009,0-.024,0-.026-.008s0-.024.014-.019a.139.139,0,0,1,.026.017Z",
  transform: "translate(-504.796 -1879.57)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1209",
  "data-name": "Path 1209",
  d: "M592.73,1760.218l-.027,0c0-.006,0-.016,0-.017a.145.145,0,0,1,.027,0Z",
  transform: "translate(-399.948 -1509.383)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1210",
  "data-name": "Path 1210",
  d: "M467.594,1766.692l0,.019a.116.116,0,0,1-.024-.014.062.062,0,0,1,0-.017Z",
  transform: "translate(-277.791 -1515.709)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1211",
  "data-name": "Path 1211",
  d: "M756.913,1128.335a1.269,1.269,0,0,1,1.459-.935,14.556,14.556,0,0,1,3.679,1.146c.472.342.324.588.324.588s-.036.225-1.146-.106C758.166,1128.118,756.681,1128.8,756.913,1128.335Z",
  transform: "translate(-560.224 -891.63)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1212",
  "data-name": "Path 1212",
  d: "M759.272,1126.364a3.592,3.592,0,0,1-.93-.185,11.615,11.615,0,0,0-3.721-.509c-.4.005-.581.007-.647-.1a.187.187,0,0,1,.007-.179,1.342,1.342,0,0,1,1.536-.978,14.724,14.724,0,0,1,3.708,1.156c.472.342.375.615.347.67a.132.132,0,0,1-.059.069A.462.462,0,0,1,759.272,1126.364Zm-4.333-.832a11.677,11.677,0,0,1,3.442.517c.879.262,1.044.161,1.061.146l.005-.01s.1-.2-.305-.5a14.474,14.474,0,0,0-3.649-1.133,1.191,1.191,0,0,0-1.381.884.063.063,0,0,1-.005.013c-.019.038-.016.051-.016.051a1.588,1.588,0,0,0,.527.031q.143,0,.321,0Z",
  transform: "translate(-557.358 -888.715)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1213",
  "data-name": "Path 1213",
  d: "M830.773,983.069l-.214-.555,2.173-.74s.818.192.632,1.463a1.374,1.374,0,0,0,.352.468.149.149,0,0,1-.057.258,2.524,2.524,0,0,1-.319.072c-.008.049.151,1-.092,1.106-.617.267-2.109-.311-2.115-1.2a.646.646,0,0,1-.777-.326A.376.376,0,0,1,830.773,983.069Z",
  transform: "translate(-631.903 -749.492)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1214",
  "data-name": "Path 1214",
  d: "M829.987,982.417a2.29,2.29,0,0,1-1.175-.37,1.257,1.257,0,0,1-.63-.883.7.7,0,0,1-.777-.387.448.448,0,0,1,.041-.465.493.493,0,0,1,.341-.168l-.177-.46a.067.067,0,0,1,0-.054.068.068,0,0,1,.04-.036l2.173-.742a.073.073,0,0,1,.038,0c.009,0,.869.22.687,1.52a1.322,1.322,0,0,0,.324.425.218.218,0,0,1-.083.378c-.116.031-.2.052-.264.064,0,.014,0,.03,0,.046.053.5.072.971-.143,1.066A1.026,1.026,0,0,1,829.987,982.417Zm-1.74-1.41a.07.07,0,0,1,.026.005.069.069,0,0,1,.038.037.07.07,0,0,1,.005.026,1.119,1.119,0,0,0,.572.853,1.787,1.787,0,0,0,1.445.289c.069-.03.136-.214.061-.925a.652.652,0,0,1-.009-.129.069.069,0,0,1,.021-.039.07.07,0,0,1,.041-.018,2.265,2.265,0,0,0,.307-.07.077.077,0,0,0,.057-.059.08.08,0,0,0-.027-.079,1.425,1.425,0,0,1-.37-.495.069.069,0,0,1,0-.037c.161-1.1-.444-1.341-.561-1.38l-2.083.712.188.489a.07.07,0,0,1-.075.092.37.37,0,0,0-.324.114.32.32,0,0,0-.02.329.58.58,0,0,0,.694.284Z",
  transform: "translate(-629.019 -746.637)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1215",
  "data-name": "Path 1215",
  d: "M940.663,1039.232c.051,0,.087-.075.08-.159s-.055-.147-.106-.142-.087.076-.08.159S940.612,1039.236,940.663,1039.232Z",
  transform: "translate(-739.518 -805.288)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1216",
  "data-name": "Path 1216",
  d: "M926.54,1026.7a.069.069,0,0,1-.035-.129c.333-.2.52-.112.54-.1a.069.069,0,0,1-.01.125.071.071,0,0,1-.051,0,.508.508,0,0,0-.409.1A.068.068,0,0,1,926.54,1026.7Z",
  transform: "translate(-725.767 -793.098)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1217",
  "data-name": "Path 1217",
  d: "M841.372,1046.946a.068.068,0,0,1-.061-.037l-.157-.3a.069.069,0,0,1,.123-.064l.157.3a.07.07,0,0,1-.029.093.072.072,0,0,1-.032.009Z",
  transform: "translate(-642.475 -812.684)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1218",
  "data-name": "Path 1218",
  d: "M844.142,1048.9a.069.069,0,0,1-.043-.017.07.07,0,0,1-.022-.041.068.068,0,0,1,.008-.045.07.07,0,0,1,.035-.031l.235-.076a.07.07,0,0,1,.053,0,.07.07,0,0,1,.03.094.071.071,0,0,1-.041.034l-.235.076Z",
  transform: "translate(-645.336 -814.814)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1219",
  "data-name": "Path 1219",
  d: "M935.976,1076.507s-.1-.041-.427.343.314,0,.638,0S936.345,1076.576,935.976,1076.507Z",
  transform: "translate(-734.54 -841.969)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1220",
  "data-name": "Path 1220",
  d: "M932.56,1074.22a.1.1,0,0,1-.052-.009.1.1,0,0,1-.04-.034c-.046-.07.02-.158.092-.242.286-.332.427-.385.5-.365.258.049.448.2.436.334,0,.046-.036.146-.242.146a1.622,1.622,0,0,0-.419.1A1.028,1.028,0,0,1,932.56,1074.22Zm.471-.514c-.016,0-.119.034-.364.319l-.035.043c.046-.013.108-.033.157-.049a1.662,1.662,0,0,1,.462-.108c.073,0,.1-.016.1-.022C933.36,1073.86,933.252,1073.747,933.032,1073.706Z",
  transform: "translate(-731.607 -839.099)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1221",
  "data-name": "Path 1221",
  d: "M821.3,931.588a1.527,1.527,0,0,1,.375.324.165.165,0,0,0,.283-.051c.164-.468.571.248.582-.45,0-.277-.345-.792.313-.6,1.164.344-.046-.486,1.387-.12.7.18.879-.971-.873-1a.691.691,0,0,0,.258-.231c.3-.54-1.912-.709-2.3.637C819.934,930.173,821.036,931.52,821.3,931.588Z",
  transform: "translate(-622.455 -698.035)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1222",
  "data-name": "Path 1222",
  d: "M818.969,929.218a.23.23,0,0,1-.1-.022.233.233,0,0,1-.08-.063,1.511,1.511,0,0,0-.351-.307,1.473,1.473,0,0,1-.7-1.13c.02-.2.16-.448.708-.49a1.6,1.6,0,0,1,1.307-1.008,1.242,1.242,0,0,1,1.094.2.244.244,0,0,1,.008.271.542.542,0,0,1-.115.135c.871.061,1.125.408,1.2.562a.408.408,0,0,1-.044.441.479.479,0,0,1-.5.126c-.462-.119-.624-.1-.676-.069-.022.014-.027.035-.036.083a.211.211,0,0,1-.026.09.208.208,0,0,1-.062.07c-.093.057-.264.042-.59-.055-.219-.065-.277-.035-.3-.02-.04.038,0,.174.024.283a1.09,1.09,0,0,1,.046.269c0,.2-.036.307-.109.361a.272.272,0,0,1-.242.009c-.117-.033-.181-.051-.235.1a.232.232,0,0,1-.179.154.227.227,0,0,1-.042,0Zm1.146-2.913a2.043,2.043,0,0,0-.34.029,1.454,1.454,0,0,0-1.211.957.07.07,0,0,1-.063.05c-.393.021-.6.145-.627.37a1.367,1.367,0,0,0,.61.985l.017.006a1.592,1.592,0,0,1,.395.342.1.1,0,0,0,.093.033.093.093,0,0,0,.045-.021.092.092,0,0,0,.028-.042.28.28,0,0,1,.4-.19c.05.014.1.029.122.013s.049-.057.053-.251a.986.986,0,0,0-.043-.231c-.041-.159-.084-.324.014-.416.076-.073.213-.077.431-.013.348.1.448.088.478.07.013-.008.017-.025.024-.066a.232.232,0,0,1,.1-.176c.082-.053.24-.088.786.051a.345.345,0,0,0,.36-.08.272.272,0,0,0,.024-.294c-.05-.111-.292-.474-1.275-.49a.069.069,0,0,1-.066-.051.068.068,0,0,1,0-.044.07.07,0,0,1,.029-.034.626.626,0,0,0,.234-.2.106.106,0,0,0,0-.123.824.824,0,0,0-.619-.181Z",
  transform: "translate(-619.62 -695.21)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1223",
  "data-name": "Path 1223",
  d: "M868.164,1104.489h0a.783.783,0,0,1-.425-.275l0-.006a.018.018,0,0,1,0-.007.017.017,0,0,1,0-.006l0-.005a.017.017,0,0,1,.024,0,.746.746,0,0,0,.406.263.017.017,0,0,1,.011.006.018.018,0,0,1,0,.013.017.017,0,0,1-.006.011.018.018,0,0,1-.013,0Z",
  transform: "translate(-668.427 -868.99)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1224",
  "data-name": "Path 1224",
  d: "M1328.752,1484.189a.07.07,0,0,1-.043-.016.069.069,0,0,1-.018-.085.069.069,0,0,1,.033-.032l4.691-2.127a.067.067,0,0,1,.027-.008.071.071,0,0,1,.028,0,.069.069,0,0,1,.041.037.071.071,0,0,1,.006.027.067.067,0,0,1-.005.028.072.072,0,0,1-.039.038l-4.691,2.127a.068.068,0,0,1-.029.006Z",
  transform: "translate(-1118.403 -1237.731)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1225",
  "data-name": "Path 1225",
  d: "M1251.472,1434.613a.068.068,0,0,1-.031-.007,4.986,4.986,0,0,1-1.9-2.146c-.832-1.583-2.611-4.655-2.629-4.686a.07.07,0,0,1-.007-.053.069.069,0,0,1,.127-.017c.018.031,1.8,3.1,2.632,4.691a4.959,4.959,0,0,0,1.84,2.087.067.067,0,0,1,.032.033.07.07,0,0,1-.02.084.069.069,0,0,1-.043.015Z",
  transform: "translate(-1038.569 -1184.771)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1226",
  "data-name": "Path 1226",
  d: "M1553.957,644.082h-.006l-.6-.046a.07.07,0,0,1-.064-.075.072.072,0,0,1,.024-.048.07.07,0,0,1,.051-.017l.6.046a.07.07,0,0,1,.048.022.068.068,0,0,1,.019.05.07.07,0,0,1-.022.048A.07.07,0,0,1,1553.957,644.082Z",
  transform: "translate(-1337.663 -419.66)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1227",
  "data-name": "Path 1227",
  d: "M1532.568,664.52h0l-1.623-.09a.07.07,0,0,1-.026-.007.073.073,0,0,1-.022-.016.069.069,0,0,1-.014-.023.067.067,0,0,1,0-.027.07.07,0,0,1,.073-.065l1.623.09a.07.07,0,0,1,.026.006.066.066,0,0,1,.022.016.071.071,0,0,1,.015.023.071.071,0,0,1,0,.053.069.069,0,0,1-.039.037A.07.07,0,0,1,1532.568,664.52Z",
  transform: "translate(-1315.781 -439.57)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1228",
  "data-name": "Path 1228",
  d: "M1759.291,656.315h0l-.514-.021a.069.069,0,1,1,.006-.139l.514.021a.069.069,0,0,1,.048.021.07.07,0,0,1,0,.1.07.07,0,0,1-.05.019Z",
  transform: "translate(-1538.189 -431.627)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1229",
  "data-name": "Path 1229",
  d: "M1737.785,674.565h0l-1.48-.079a.069.069,0,0,1-.048-.023.071.071,0,0,1-.014-.023.069.069,0,0,1,0-.027.068.068,0,0,1,.046-.062.067.067,0,0,1,.027,0l1.479.079a.069.069,0,0,1,.068.071.069.069,0,0,1-.021.049.07.07,0,0,1-.05.019Z",
  transform: "translate(-1516.251 -449.386)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1230",
  "data-name": "Path 1230",
  d: "M1980.182,674.519a1.71,1.71,0,0,1-.246-.024,1.564,1.564,0,0,0-.226-.023.069.069,0,0,1,0-.139,1.652,1.652,0,0,1,.246.024,1.548,1.548,0,0,0,.226.022.069.069,0,1,1,0,.139Z",
  transform: "translate(-1753.86 -449.373)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1231",
  "data-name": "Path 1231",
  d: "M1953.63,693.429h-.006l-1.52-.129a.071.071,0,0,1-.026-.008.072.072,0,0,1-.021-.017.074.074,0,0,1-.013-.024.067.067,0,0,1,0-.027.074.074,0,0,1,.007-.026.071.071,0,0,1,.017-.021.073.073,0,0,1,.024-.013.071.071,0,0,1,.027,0l1.52.128a.069.069,0,0,1,.048.022.069.069,0,0,1-.054.116Z",
  transform: "translate(-1726.918 -467.751)",
  fill: "#13484f"
}))));
export default __webpack_public_path__ + "static/media/MoverIllustrationUnicorn.56e60c99.svg";
export { SvgComponent as ReactComponent };